// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDocumentType {
    id: number;
    value: string;
    formNumber: string;
    displayValue: string;
    description: string;
    active: boolean;
    sortOrder: number;
}

export class DocumentType implements IDocumentType, IBaseType {
    public id: number;
    public value: string;
    public formNumber: string;
    public displayValue: string;
    public description: string;
    public active: boolean;
    public sortOrder: number;

    /**
        Returns FP AVIS Title DocumentType
    **/
    get AVISTitle(): IDocumentType {
        return this.FromId(2293);
    }
    /**
        Returns AADA Title DocumentType
    **/
    get AADATitle(): IDocumentType {
        return this.FromId(2294);
    }
    /**
        Returns FP Enterprise Title DocumentType
    **/
    get EnterpriseTitle(): IDocumentType {
        return this.FromId(2295);
    }
    /**
        Returns FP Enterprise Registration and Tab DocumentType
    **/
    get EnterpriseRegistration(): IDocumentType {
        return this.FromId(2296);
    }
    /**
        Returns AADA Registration DocumentType
    **/
    get AADARegistration(): IDocumentType {
        return this.FromId(2297);
    }
    /**
        Returns FP ECD Registration and Tab DocumentType
    **/
    get LECURegistration(): IDocumentType {
        return this.FromId(2300);
    }
    /**
        Returns Customer Document DocumentType
    **/
    get CustomerDocument(): IDocumentType {
        return this.FromId(2305);
    }
    /**
        Returns FP Special Projects IT Registration DocumentType
    **/
    get SpecialProjectsITRegistration(): IDocumentType {
        return this.FromId(2308);
    }
    /**
        Returns FP Special Projects IT Off Highway DocumentType
    **/
    get SpecialProjectsITOffHighway(): IDocumentType {
        return this.FromId(2309);
    }
    /**
        Returns FP Special Projects IT Vehicle Title DocumentType
    **/
    get SpecialProjectsITVehicleTitle(): IDocumentType {
        return this.FromId(2310);
    }
    /**
        Returns Affidavit for 90 Day Non-Resident Permit DocumentType
    **/
    get NinetyDayNonResidentPermitAffidavit(): IDocumentType {
        return this.FromId(2312);
    }
    /**
        Returns FP Renew Registration Overage Notice DocumentType
    **/
    get RenewRegistrationOverageNotice(): IDocumentType {
        return this.FromId(2313);
    }
    /**
        Returns U.S. Birth Certificate or Birth Abroad DocumentType
    **/
    get USBirthCertificateorBirthAbroad(): IDocumentType {
        return this.FromId(152);
    }
    /**
        Returns US Passport/ Passport Card DocumentType
    **/
    get USPassportPassportCard(): IDocumentType {
        return this.FromId(156);
    }
    /**
        Returns Expired US Passport/ Passport Card DocumentType
    **/
    get ExpiredUSPassportPassportCard(): IDocumentType {
        return this.FromId(157);
    }
    /**
        Returns REAL ID DL DocumentType
    **/
    get REALIDDL(): IDocumentType {
        return this.FromId(179);
    }
    /**
        Returns OOS DL DocumentType
    **/
    get OOSDL(): IDocumentType {
        return this.FromId(231);
    }
    /**
        Returns I-94 (Arrival/Departure Record) in Unexpired Foreign Passport DocumentType
    **/
    get I94ArrivalDepartureRecordinUnexpiredForeignPassport(): IDocumentType {
        return this.FromId(162);
    }
    /**
        Returns I-94 with photo DocumentType
    **/
    get I94withphoto(): IDocumentType {
        return this.FromId(164);
    }
    /**
        Returns I-551 Permanent Resident Card  DocumentType
    **/
    get I551(): IDocumentType {
        return this.FromId(160);
    }
    /**
        Returns Expired I-551 Permanent Resident Card DocumentType
    **/
    get ExpiredI551(): IDocumentType {
        return this.FromId(161);
    }
    /**
        Returns Employment Authorization Card DocumentType
    **/
    get EAC(): IDocumentType {
        return this.FromId(167);
    }
    /**
        Returns Utility Bill DocumentType
    **/
    get UtilityBill(): IDocumentType {
        return this.FromId(211);
    }
    /**
        Returns Property Deed, Monthly Mortgage statement/payment booklet, lease agreement DocumentType
    **/
    get PropertyDeedMonthlyMortgagestatementpaymentbookletleaseagreement(): IDocumentType {
        return this.FromId(209);
    }
    /**
        Returns Name Change Decree DocumentType
    **/
    get NameChangeDecree(): IDocumentType {
        return this.FromId(202);
    }
    /**
        Returns U.S (or territory) Marriage Certificate  DocumentType
    **/
    get USorterritoryMarriageCertificate(): IDocumentType {
        return this.FromId(195);
    }
    /**
        Returns Divorce Decree DocumentType
    **/
    get DivorceDecree(): IDocumentType {
        return this.FromId(199);
    }
    /**
        Returns Amended Birth Certificate DocumentType
    **/
    get AmendedBirthCertificate(): IDocumentType {
        return this.FromId(230);
    }
    /**
        Returns Bank/Credit Card Statement DocumentType
    **/
    get BankCreditCardStatement(): IDocumentType {
        return this.FromId(215);
    }
    /**
        Returns Mail from Government Agency DocumentType
    **/
    get MailfromGovernmentAgency(): IDocumentType {
        return this.FromId(216);
    }
    /**
        Returns Homeowner/Renter Insurance DocumentType
    **/
    get HomeownerRenterInsurance(): IDocumentType {
        return this.FromId(213);
    }
    /**
        Returns Dealer Acquisition Contract DocumentType
    **/
    get DealerAcquisitionContract(): IDocumentType {
        return this.FromId(2301);
    }
    /**
        Returns Dealer Reassignment Form DocumentType
    **/
    get DealerReassignmentForm(): IDocumentType {
        return this.FromId(2302);
    }
    /**
        Returns FP AVIS Registration and Tab DocumentType
    **/
    get AVISVehicleRegistration(): IDocumentType {
        return this.FromId(2292);
    }
    /**
        Returns FP UHaul Title DocumentType
    **/
    get UHaulTitle(): IDocumentType {
        return this.FromId(2306);
    }
    /**
        Returns FP Litter Letter DocumentType
    **/
    get FPLitterLetter(): IDocumentType {
        return this.FromId(2315);
    }
    /**
        Returns FP IID Deferment Revoked Notice DocumentType
    **/
    get FPIIDDefermentRevokedNotice(): IDocumentType {
        return this.FromId(2320);
    }
    /**
        Returns IID Deferment Revoked Notice DocumentType
    **/
    get IIDDefermentRevokedNotice(): IDocumentType {
        return this.FromId(2321);
    }
    /**
        Returns Driver License Renewal Invitation DocumentType
    **/
    get DriverLicenseRenewalInvitation(): IDocumentType {
        return this.FromId(2327);
    }
    /**
        Returns FP Driver License Renewal Invitation DocumentType
    **/
    get FormPortDriverLicenseRenewalInvitation(): IDocumentType {
        return this.FromId(2328);
    }
    /**
        Returns FP ECD Off Highway Vehicle Decal Authorization DocumentType
    **/
    get FPECDOffHighwayVehicleDecalAuthorization(): IDocumentType {
        return this.FromId(2330);
    }
    /**
        Returns Miscellaneous Reversal Receipt DocumentType
    **/
    get ReversalReceipt(): IDocumentType {
        return this.FromId(2307);
    }
    /**
        Returns FP TTEAP DocumentType
    **/
    get FormPortTTEAP(): IDocumentType {
        return this.FromId(2314);
    }
    /**
        Returns TTEAP DocumentType
    **/
    get TTEAP(): IDocumentType {
        return this.FromId(2316);
    }
    /**
        Returns Litter Letter DocumentType
    **/
    get LitterLetter(): IDocumentType {
        return this.FromId(2325);
    }
    /**
        Returns Disability - Hearing Impaired Plate/Placard Application DocumentType
    **/
    get DisabilityHearingImpairedPlatePlacardApplication(): IDocumentType {
        return this.FromId(100);
    }
    /**
        Returns Placard Renewal Replacement Request DocumentType
    **/
    get PlacardRenewalReplacementRequest(): IDocumentType {
        return this.FromId(101);
    }
    /**
        Returns Military Orders DocumentType
    **/
    get MilitaryOrders(): IDocumentType {
        return this.FromId(102);
    }
    /**
        Returns Special Military Exemption DocumentType
    **/
    get SpecialtyMilitaryExemption(): IDocumentType {
        return this.FromId(103);
    }
    /**
        Returns Affidavit Exempt Non-Resident Service Personnel DocumentType
    **/
    get AffidavitExemptNonResidentServicePersonnel(): IDocumentType {
        return this.FromId(104);
    }
    /**
        Returns VA Letter 100% Disabled Rate DocumentType
    **/
    get VALetter100PercentDisabledRate(): IDocumentType {
        return this.FromId(105);
    }
    /**
        Returns VA Letter DocumentType
    **/
    get VALetter(): IDocumentType {
        return this.FromId(106);
    }
    /**
        Returns Lease Contract DocumentType
    **/
    get LeaseContract(): IDocumentType {
        return this.FromId(107);
    }
    /**
        Returns School District Letter DocumentType
    **/
    get SchoolDistrictLetter(): IDocumentType {
        return this.FromId(108);
    }
    /**
        Returns County Assessor Exemption Letter DocumentType
    **/
    get CountyAssessorExemptionLetter(): IDocumentType {
        return this.FromId(109);
    }
    /**
        Returns Organization Headquarters Letter DocumentType
    **/
    get OrganizationHeadquartersLetter(): IDocumentType {
        return this.FromId(110);
    }
    /**
        Returns IRS 501(c)(3) Exemption Ruling DocumentType
    **/
    get IRS501c3ExemptionRuling(): IDocumentType {
        return this.FromId(111);
    }
    /**
        Returns Benefit Award Letter SSA/Benefit Verification DocumentType
    **/
    get BenefitAwardLetterSSABenefitVerification(): IDocumentType {
        return this.FromId(112);
    }
    /**
        Returns VLT Tribal Exemption DocumentType
    **/
    get VLTTribalExemption(): IDocumentType {
        return this.FromId(113);
    }
    /**
        Returns Waiver/Letter From Tribal Council DocumentType
    **/
    get WaiverLetterFromTribalCouncil(): IDocumentType {
        return this.FromId(114);
    }
    /**
        Returns Assessor's Office Document DocumentType
    **/
    get AssessorsOfficeDocument(): IDocumentType {
        return this.FromId(115);
    }
    /**
        Returns Title and Registration Application Service Option 18 DocumentType
    **/
    get TnRApplicationServiceOption18(): IDocumentType {
        return this.FromId(116);
    }
    /**
        Returns Survivor Fallen Responder Exemption DocumentType
    **/
    get SurvivorFallenResponderExemption(): IDocumentType {
        return this.FromId(117);
    }
    /**
        Returns Survivor Fallen Military Member Exemption DocumentType
    **/
    get SurvivorFallenMilitaryMemberExemption(): IDocumentType {
        return this.FromId(119);
    }
    /**
        Returns DD Form 1300 Report of Casualty DocumentType
    **/
    get DDForm1300ReportofCasualty(): IDocumentType {
        return this.FromId(120);
    }
    /**
        Returns 100% Disabled Exemption Renewal Affirmation DocumentType
    **/
    get OneHundredPercentDisabledExemptionRenewalAffirmation(): IDocumentType {
        return this.FromId(121);
    }
    /**
        Returns FP Vehicle Title DocumentType
    **/
    get VehicleTitle(): IDocumentType {
        return this.FromId(122);
    }
    /**
        Returns DD 214 DocumentType
    **/
    get DD214(): IDocumentType {
        return this.FromId(123);
    }
    /**
        Returns DD 215 DocumentType
    **/
    get DD215(): IDocumentType {
        return this.FromId(124);
    }
    /**
        Returns WD AGO 52-98 DocumentType
    **/
    get WDAGO5298(): IDocumentType {
        return this.FromId(125);
    }
    /**
        Returns WD AGO 53-55 DocumentType
    **/
    get WDAGO5355(): IDocumentType {
        return this.FromId(126);
    }
    /**
        Returns NAVPERS 553 DocumentType
    **/
    get NAVPERS553(): IDocumentType {
        return this.FromId(127);
    }
    /**
        Returns NAVMC 78 DocumentType
    **/
    get NAVMC78(): IDocumentType {
        return this.FromId(128);
    }
    /**
        Returns FCC License DocumentType
    **/
    get FCCLicense(): IDocumentType {
        return this.FromId(129);
    }
    /**
        Returns Reduced Motor Carrier Fee Certificate DocumentType
    **/
    get ReducedMotorCarrierFeeCertificate(): IDocumentType {
        return this.FromId(130);
    }
    /**
        Returns FCC-issued Amateur Radio License DocumentType
    **/
    get FCCissuedAmateurRadioLicense(): IDocumentType {
        return this.FromId(131);
    }
    /**
        Returns Former Prisoner Of War Certificate DocumentType
    **/
    get FormerPOWCertificate(): IDocumentType {
        return this.FromId(132);
    }
    /**
        Returns International Association of Firefighters Application DocumentType
    **/
    get IAFFApplication(): IDocumentType {
        return this.FromId(133);
    }
    /**
        Returns Fraternal Order of Police Application DocumentType
    **/
    get FOPApplication(): IDocumentType {
        return this.FromId(134);
    }
    /**
        Returns Veterans Service form AVSC02-025 part II DocumentType
    **/
    get VeteransServiceformAVSC02025partII(): IDocumentType {
        return this.FromId(135);
    }
    /**
        Returns Consular Identification Card DocumentType
    **/
    get ConsularIdentificationCard(): IDocumentType {
        return this.FromId(136);
    }
    /**
        Returns Statement of Honorable Discharge DocumentType
    **/
    get StatementofHonorableDischarge(): IDocumentType {
        return this.FromId(137);
    }
    /**
        Returns American Legion Card DocumentType
    **/
    get AmericanLegionCard(): IDocumentType {
        return this.FromId(138);
    }
    /**
        Returns Disabled American Veteran Card DocumentType
    **/
    get DisabledAmericanVeteranCard(): IDocumentType {
        return this.FromId(139);
    }
    /**
        Returns Military Officers Of America Card DocumentType
    **/
    get MilitaryOfficersOfAmericaCard(): IDocumentType {
        return this.FromId(140);
    }
    /**
        Returns Veterans Administration Medical Card DocumentType
    **/
    get VeteransAdministrationMedicalCard(): IDocumentType {
        return this.FromId(141);
    }
    /**
        Returns Veterans Of Foreign Wars Card DocumentType
    **/
    get VeteransOfForeignWarsCard(): IDocumentType {
        return this.FromId(142);
    }
    /**
        Returns Military Order Of The Purple Heart DocumentType
    **/
    get MilitaryOrderOfThePurpleHeart(): IDocumentType {
        return this.FromId(143);
    }
    /**
        Returns Vietnam Veterans Of America Card DocumentType
    **/
    get VietnamVeteransOfAmericaCard(): IDocumentType {
        return this.FromId(144);
    }
    /**
        Returns Active Duty Military Card DocumentType
    **/
    get ActiveDutyMilitaryCard(): IDocumentType {
        return this.FromId(145);
    }
    /**
        Returns Inactive Duty Military Card DocumentType
    **/
    get InactiveDutyMilitaryCard(): IDocumentType {
        return this.FromId(146);
    }
    /**
        Returns Arizona Driver License with Veteran mark DocumentType
    **/
    get ArizonaDriverLicensewithVeteranmark(): IDocumentType {
        return this.FromId(147);
    }
    /**
        Returns Arizona Commercial Driver License with Veteran mark DocumentType
    **/
    get ArizonaCommercialDriverLicensewithVeteranmark(): IDocumentType {
        return this.FromId(148);
    }
    /**
        Returns Arizona Instructional Permit with Veteran mark DocumentType
    **/
    get ArizonaInstructionalPermitwithVeteranmark(): IDocumentType {
        return this.FromId(149);
    }
    /**
        Returns Arizona Identification Card with Veteran mark DocumentType
    **/
    get ArizonaIdentificationCardwithVeteranmark(): IDocumentType {
        return this.FromId(150);
    }
    /**
        Returns Affidavit from Commanding Officer DocumentType
    **/
    get AffidavitfromCommandingOfficer(): IDocumentType {
        return this.FromId(151);
    }
    /**
        Returns Delayed US Birth Certificate DocumentType
    **/
    get DelayedUSBirthCertificate(): IDocumentType {
        return this.FromId(153);
    }
    /**
        Returns Arizona Certificate of Foreign Birth  DocumentType
    **/
    get ArizonaCertificateofForeignBirth(): IDocumentType {
        return this.FromId(154);
    }
    /**
        Returns Tribal or Bureau of Indian Affairs Affidavit of Birth DocumentType
    **/
    get TribalorBureauofIndianAffairsAffidavitofBirth(): IDocumentType {
        return this.FromId(155);
    }
    /**
        Returns U.S. Certificate of Naturalization DocumentType
    **/
    get USCertificateofNaturalization(): IDocumentType {
        return this.FromId(158);
    }
    /**
        Returns U.S. Certificate of Citizenship DocumentType
    **/
    get USCertificateofCitizenship(): IDocumentType {
        return this.FromId(159);
    }
    /**
        Returns Temporary I-551 Stamp (on passport or I- 94) DocumentType
    **/
    get TemporaryI551StamponpassportorI94(): IDocumentType {
        return this.FromId(163);
    }
    /**
        Returns I-94 without photo DocumentType
    **/
    get I94withoutphoto(): IDocumentType {
        return this.FromId(165);
    }
    /**
        Returns I-571 Refugee Travel Document DocumentType
    **/
    get I571(): IDocumentType {
        return this.FromId(166);
    }
    /**
        Returns U.S. Military ID Card (reserve or retired) DocumentType
    **/
    get USMilitaryIDCardreserveorretired(): IDocumentType {
        return this.FromId(168);
    }
    /**
        Returns U.S. Military Dependent ID Card DocumentType
    **/
    get USMilitaryDependentIDCard(): IDocumentType {
        return this.FromId(169);
    }
    /**
        Returns U.S. Armed Forces Driver License DocumentType
    **/
    get USArmedForcesDriverLicense(): IDocumentType {
        return this.FromId(170);
    }
    /**
        Returns U.S. Department of Veteran’s Affairs Card DocumentType
    **/
    get USDepartmentofVeteransAffairsCard(): IDocumentType {
        return this.FromId(171);
    }
    /**
        Returns Selective Service Card DocumentType
    **/
    get SelectiveServiceCard(): IDocumentType {
        return this.FromId(172);
    }
    /**
        Returns OOS Enhanced DL DocumentType
    **/
    get OOSEnhancedDL(): IDocumentType {
        return this.FromId(173);
    }
    /**
        Returns OOS Enhanced CDL DocumentType
    **/
    get OOSEnhancedCDL(): IDocumentType {
        return this.FromId(174);
    }
    /**
        Returns OOS Enhanced ID DocumentType
    **/
    get OOSEnhancedID(): IDocumentType {
        return this.FromId(175);
    }
    /**
        Returns OOS IP DocumentType
    **/
    get OOSIP(): IDocumentType {
        return this.FromId(176);
    }
    /**
        Returns OOS CLP DocumentType
    **/
    get OOSCLP(): IDocumentType {
        return this.FromId(177);
    }
    /**
        Returns OOS ID Card DocumentType
    **/
    get OOSIDCard(): IDocumentType {
        return this.FromId(178);
    }
    /**
        Returns REAL ID CDL DocumentType
    **/
    get REALIDCDL(): IDocumentType {
        return this.FromId(180);
    }
    /**
        Returns REAL ID ID Card DocumentType
    **/
    get REALIDIDCard(): IDocumentType {
        return this.FromId(181);
    }
    /**
        Returns MVR DocumentType
    **/
    get MVR(): IDocumentType {
        return this.FromId(182);
    }
    /**
        Returns Enhanced Tribal Card DocumentType
    **/
    get EnhancedTribalCard(): IDocumentType {
        return this.FromId(183);
    }
    /**
        Returns Tribal Certificate of Indian Blood DocumentType
    **/
    get TribalCertificateofIndianBlood(): IDocumentType {
        return this.FromId(184);
    }
    /**
        Returns W-2 Form DocumentType
    **/
    get W2Form(): IDocumentType {
        return this.FromId(185);
    }
    /**
        Returns Inmate ID Card DocumentType
    **/
    get InmateIDCard(): IDocumentType {
        return this.FromId(186);
    }
    /**
        Returns Affidavit of Identification(DOC) DocumentType
    **/
    get AffidavitofIdentificationDOC(): IDocumentType {
        return this.FromId(187);
    }
    /**
        Returns Released Offender ID DocumentType
    **/
    get ReleasedOffenderID(): IDocumentType {
        return this.FromId(188);
    }
    /**
        Returns Affidavit of Identification (Maricopa Co. Adult Probation) DocumentType
    **/
    get AffidavitofIdentificationMaricopaCoAdultProbation(): IDocumentType {
        return this.FromId(189);
    }
    /**
        Returns Community Re-Entry ID DocumentType
    **/
    get CommunityReEntryID(): IDocumentType {
        return this.FromId(190);
    }
    /**
        Returns Social Security Card DocumentType
    **/
    get SocialSecurityCard(): IDocumentType {
        return this.FromId(191);
    }
    /**
        Returns 1099 Form DocumentType
    **/
    get OneThousandAndNinetyNineForm(): IDocumentType {
        return this.FromId(192);
    }
    /**
        Returns Paystub showing SSN DocumentType
    **/
    get PaystubshowingSSN(): IDocumentType {
        return this.FromId(193);
    }
    /**
        Returns Concealed Weapons Permit/License DocumentType
    **/
    get ConcealedWeaponsPermitLicense(): IDocumentType {
        return this.FromId(194);
    }
    /**
        Returns Certified Letter of Identification for a Ward of the Court DocumentType
    **/
    get CertifiedLetterofIdentificationforaWardoftheCourt(): IDocumentType {
        return this.FromId(196);
    }
    /**
        Returns Adoption Decree DocumentType
    **/
    get AdoptionDecree(): IDocumentType {
        return this.FromId(197);
    }
    /**
        Returns Bankruptcy Decree DocumentType
    **/
    get BankruptcyDecree(): IDocumentType {
        return this.FromId(198);
    }
    /**
        Returns Emancipation Decree DocumentType
    **/
    get EmancipationDecree(): IDocumentType {
        return this.FromId(200);
    }
    /**
        Returns Legal Guardian Decree DocumentType
    **/
    get LegalGuardianDecree(): IDocumentType {
        return this.FromId(201);
    }
    /**
        Returns Professional License DocumentType
    **/
    get ProfessionalLicense(): IDocumentType {
        return this.FromId(203);
    }
    /**
        Returns Employee ID Badge with Photo DocumentType
    **/
    get EmployeeIDBadgewithPhoto(): IDocumentType {
        return this.FromId(204);
    }
    /**
        Returns School ID with Photo DocumentType
    **/
    get SchoolIDwithPhoto(): IDocumentType {
        return this.FromId(205);
    }
    /**
        Returns Medical Insurance Card  DocumentType
    **/
    get MedicalInsuranceCard(): IDocumentType {
        return this.FromId(206);
    }
    /**
        Returns Legal Guardian Certificate DocumentType
    **/
    get LegalGuardianCertificate(): IDocumentType {
        return this.FromId(207);
    }
    /**
        Returns Mortgage Document DocumentType
    **/
    get MortgageDocument(): IDocumentType {
        return this.FromId(208);
    }
    /**
        Returns Voter Registration Card DocumentType
    **/
    get VoterRegistrationCard(): IDocumentType {
        return this.FromId(210);
    }
    /**
        Returns Health Insurance Card w/ address DocumentType
    **/
    get HealthInsuranceCardwaddress(): IDocumentType {
        return this.FromId(212);
    }
    /**
        Returns Report Card or Transcript DocumentType
    **/
    get ReportCardorTranscript(): IDocumentType {
        return this.FromId(214);
    }
    /**
        Returns Auto Payment Book/Statement DocumentType
    **/
    get AutoPaymentBookStatement(): IDocumentType {
        return this.FromId(217);
    }
    /**
        Returns Vehicle Loan Document DocumentType
    **/
    get VehicleLoanDocument(): IDocumentType {
        return this.FromId(218);
    }
    /**
        Returns Paycheck/Paystub without SSN DocumentType
    **/
    get PaycheckPaystubwithoutSSN(): IDocumentType {
        return this.FromId(219);
    }
    /**
        Returns Military Documents DocumentType
    **/
    get MilitaryDocuments(): IDocumentType {
        return this.FromId(220);
    }
    /**
        Returns Release/Parole Document (AZ) DocumentType
    **/
    get ReleaseParoleDocumentAZ(): IDocumentType {
        return this.FromId(221);
    }
    /**
        Returns Auto/Life Insurance DocumentType
    **/
    get AutoLifeInsurance(): IDocumentType {
        return this.FromId(222);
    }
    /**
        Returns USPS Change of Address confirmation/Postmarked Mail DocumentType
    **/
    get USPSChangeofAddressconfirmationPostmarkedMail(): IDocumentType {
        return this.FromId(223);
    }
    /**
        Returns Forwarded Mail DocumentType
    **/
    get ForwardedMail(): IDocumentType {
        return this.FromId(224);
    }
    /**
        Returns Court Document with Address DocumentType
    **/
    get CourtDocumentwithAddress(): IDocumentType {
        return this.FromId(225);
    }
    /**
        Returns Statement of Address from Homeless Shelter DocumentType
    **/
    get StatementofAddress(): IDocumentType {
        return this.FromId(226);
    }
    /**
        Returns AZ Address Confidentiality Program Residency Letter DocumentType
    **/
    get AZAddressConfidentialityProgramResidencyLetter(): IDocumentType {
        return this.FromId(227);
    }
    /**
        Returns AZ Address Confidentiality Program Authorization Card DocumentType
    **/
    get AZAddressConfidentialityProgramAuthorizationCard(): IDocumentType {
        return this.FromId(228);
    }
    /**
        Returns AZ Residency Affidavit DocumentType
    **/
    get AZResidencyAffidavit(): IDocumentType {
        return this.FromId(229);
    }
    /**
        Returns OOS CDL DocumentType
    **/
    get OOSCDL(): IDocumentType {
        return this.FromId(232);
    }
    /**
        Returns OOS Motorcycle DL DocumentType
    **/
    get OOSMotorcycleDL(): IDocumentType {
        return this.FromId(233);
    }
    /**
        Returns OOS Enhanced Motorcycle DL DocumentType
    **/
    get OOSEnhancedMotorcycleDL(): IDocumentType {
        return this.FromId(234);
    }
    /**
        Returns REAL ID Motorcycle DL DocumentType
    **/
    get REALIDMotorcycleDL(): IDocumentType {
        return this.FromId(235);
    }
    /**
        Returns High School Driver Education Enrollment  DocumentType
    **/
    get HighSchoolDriverEducationEnrollment(): IDocumentType {
        return this.FromId(236);
    }
    /**
        Returns High School Driver Education Certificate DocumentType
    **/
    get HighSchoolDriverEducationCertificate(): IDocumentType {
        return this.FromId(237);
    }
    /**
        Returns ATP DL Training Completion Certificate (TCC) DocumentType
    **/
    get ATPDLTrainingCompletionCertificateTCC(): IDocumentType {
        return this.FromId(238);
    }
    /**
        Returns MSF  Rider Course Completion Certificate DocumentType
    **/
    get MSFRiderCourseCompletionCertificate(): IDocumentType {
        return this.FromId(239);
    }
    /**
        Returns Total Control Completion Card DocumentType
    **/
    get TotalControlCompletionCard(): IDocumentType {
        return this.FromId(240);
    }
    /**
        Returns Special Performance Evaluation Certificate of Completion DocumentType
    **/
    get SpecialPerformanceEvaluationCertificateofCompletion(): IDocumentType {
        return this.FromId(241);
    }
    /**
        Returns Military Skills Test Waiver DocumentType
    **/
    get MilitarySkillsTestWaiver(): IDocumentType {
        return this.FromId(242);
    }
    /**
        Returns Vision Exam Report DocumentType
    **/
    get VisionExamReport(): IDocumentType {
        return this.FromId(243);
    }
    /**
        Returns Medical Professional Statement DocumentType
    **/
    get MedicalProfessionalStatement(): IDocumentType {
        return this.FromId(244);
    }
    /**
        Returns DD-2 (Retired) DocumentType
    **/
    get DD2Retired(): IDocumentType {
        return this.FromId(245);
    }
    /**
        Returns DD-2 (Reserve) DocumentType
    **/
    get DD2Reserve(): IDocumentType {
        return this.FromId(246);
    }
    /**
        Returns DD-217 DocumentType
    **/
    get DD217(): IDocumentType {
        return this.FromId(247);
    }
    /**
        Returns Original Statement of Honorable Service  DocumentType
    **/
    get OriginalStatementofHonorableService(): IDocumentType {
        return this.FromId(248);
    }
    /**
        Returns Certificate of Honorable Discharge DocumentType
    **/
    get CertificateofHonorableDischarge(): IDocumentType {
        return this.FromId(249);
    }
    /**
        Returns Affidavit of Sale DocumentType
    **/
    get AffidavitofSale(): IDocumentType {
        return this.FromId(250);
    }
    /**
        Returns Authorization to Transfer Ownership DocumentType
    **/
    get AuthorizationtoTransferOwnership(): IDocumentType {
        return this.FromId(251);
    }
    /**
        Returns Beneficiary Designation DocumentType
    **/
    get BeneficiaryDesignation(): IDocumentType {
        return this.FromId(252);
    }
    /**
        Returns Bill of Sale DocumentType
    **/
    get BillofSale(): IDocumentType {
        return this.FromId(253);
    }
    /**
        Returns Court-issued Judgement DocumentType
    **/
    get CourtissuedJudgement(): IDocumentType {
        return this.FromId(254);
    }
    /**
        Returns Court-issued Order of Forfeiture  DocumentType
    **/
    get CourtissuedOrderofForfeiture(): IDocumentType {
        return this.FromId(255);
    }
    /**
        Returns Court-issued Divorce Decree DocumentType
    **/
    get CourtissuedDivorceDecree(): IDocumentType {
        return this.FromId(256);
    }
    /**
        Returns Notice of Termination of Lease DocumentType
    **/
    get NoticeofTerminationofLease(): IDocumentType {
        return this.FromId(257);
    }
    /**
        Returns Work Order signed by owner of record DocumentType
    **/
    get WorkOrdersignedbyownerofrecord(): IDocumentType {
        return this.FromId(258);
    }
    /**
        Returns Declaration (for Arizona titled vehicles only) DocumentType
    **/
    get DeclarationforArizonatitledvehiclesonly(): IDocumentType {
        return this.FromId(259);
    }
    /**
        Returns Lessor Authorization DocumentType
    **/
    get LessorAuthorization(): IDocumentType {
        return this.FromId(260);
    }
    /**
        Returns Lien Clearance DocumentType
    **/
    get LienClearance(): IDocumentType {
        return this.FromId(261);
    }
    /**
        Returns MCO (Manufacturers Certificate of Origin) DocumentType
    **/
    get MCOManufacturersCertificateofOrigin(): IDocumentType {
        return this.FromId(262);
    }
    /**
        Returns Mechanics Lien DocumentType
    **/
    get MechanicsLein(): IDocumentType {
        return this.FromId(263);
    }
    /**
        Returns Motor Vehicle Record DocumentType
    **/
    get MotorVehicleRecord(): IDocumentType {
        return this.FromId(264);
    }
    /**
        Returns Non-Probate Affidavit DocumentType
    **/
    get NonProbateAffidavit(): IDocumentType {
        return this.FromId(265);
    }
    /**
        Returns One & The Same DocumentType
    **/
    get Onethesame(): IDocumentType {
        return this.FromId(266);
    }
    /**
        Returns Out of State MVR Lien and Title Search document DocumentType
    **/
    get OutofStateMVRLienandTitleSearch(): IDocumentType {
        return this.FromId(267);
    }
    /**
        Returns Power of Attorney DocumentType
    **/
    get PowerofAttorney(): IDocumentType {
        return this.FromId(268);
    }
    /**
        Returns Probate Court Order  DocumentType
    **/
    get ProbateCourtOrder(): IDocumentType {
        return this.FromId(269);
    }
    /**
        Returns Proof of Notification to Owner DocumentType
    **/
    get ProofofNotificationtoOwner(): IDocumentType {
        return this.FromId(270);
    }
    /**
        Returns Release of Interest DocumentType
    **/
    get ReleaseofInterest(): IDocumentType {
        return this.FromId(271);
    }
    /**
        Returns Rental Agreement DocumentType
    **/
    get RentalAgreement(): IDocumentType {
        return this.FromId(272);
    }
    /**
        Returns Repossession Affidavit DocumentType
    **/
    get RepossessionAffidavit(): IDocumentType {
        return this.FromId(273);
    }
    /**
        Returns Sheriff Sale Document DocumentType
    **/
    get SheriffSaleDocument(): IDocumentType {
        return this.FromId(274);
    }
    /**
        Returns Statement of Error DocumentType
    **/
    get StatementofError(): IDocumentType {
        return this.FromId(275);
    }
    /**
        Returns Title and Registration Application (48-0509) DocumentType
    **/
    get TitleandRegistrationApplication480509(): IDocumentType {
        return this.FromId(276);
    }
    /**
        Returns Title and Registration Application DocumentType
    **/
    get TitleandRegistrationApplication(): IDocumentType {
        return this.FromId(277);
    }
    /**
        Returns Abandoned Vehicle Report DocumentType
    **/
    get AbandonedVehicleReport(): IDocumentType {
        return this.FromId(278);
    }
    /**
        Returns Abandoned Vehicle Inspection  DocumentType
    **/
    get AbandonedVehicleInspection(): IDocumentType {
        return this.FromId(279);
    }
    /**
        Returns Vehicle Removal Written Authorization DocumentType
    **/
    get VehicleRemovalWrittenAuthorization(): IDocumentType {
        return this.FromId(280);
    }
    /**
        Returns Governing Authority Tow Permission DocumentType
    **/
    get GoverningAuthorityTowPermission(): IDocumentType {
        return this.FromId(281);
    }
    /**
        Returns Reclaimed Vehicle Notice DocumentType
    **/
    get ReclaimedVehicleNotice(): IDocumentType {
        return this.FromId(282);
    }
    /**
        Returns Law Enforcement Motorcycle Training Course Certificate DocumentType
    **/
    get LawEnforcementMotorcycleTrainingCourseCertificate(): IDocumentType {
        return this.FromId(283);
    }
    /**
        Returns CDL Demonstration Test Scoresheet  DocumentType
    **/
    get CDLDemonstrationTestScoresheet(): IDocumentType {
        return this.FromId(284);
    }
    /**
        Returns Driving Practice Certificate - Legal Guardian DocumentType
    **/
    get DrivingPracticeCertificateLegalGuradian(): IDocumentType {
        return this.FromId(285);
    }
    /**
        Returns OOS School Bus Endorsement DocumentType
    **/
    get OOSSchoolBusEndorsement(): IDocumentType {
        return this.FromId(286);
    }
    /**
        Returns OOS Passenger Endorsement DocumentType
    **/
    get OOSPassengerEndorsement(): IDocumentType {
        return this.FromId(287);
    }
    /**
        Returns OOS Tank Endorsement DocumentType
    **/
    get OOSTankEndorsement(): IDocumentType {
        return this.FromId(288);
    }
    /**
        Returns Machine Readable Immigrant Visa (with Temporary I-551 Language) DocumentType
    **/
    get MachineReadableImmigrantVisawithTemporaryI551Language(): IDocumentType {
        return this.FromId(289);
    }
    /**
        Returns Sold Notice DocumentType
    **/
    get SoldNotice(): IDocumentType {
        return this.FromId(290);
    }
    /**
        Returns De-Insured Certificate DocumentType
    **/
    get DeInsuredCertificate(): IDocumentType {
        return this.FromId(291);
    }
    /**
        Returns Permissible Use DocumentType
    **/
    get PermissibleUse(): IDocumentType {
        return this.FromId(292);
    }
    /**
        Returns Driving Practice Certificate - Driver Education DocumentType
    **/
    get DrivingPracticeCertificateDriverEducation(): IDocumentType {
        return this.FromId(293);
    }
    /**
        Returns I-20 Nonimmigrant Student Certificate DocumentType
    **/
    get I20NonimmigrantStudentCertificate(): IDocumentType {
        return this.FromId(294);
    }
    /**
        Returns I-327 Re-Entry Permit  DocumentType
    **/
    get I327ReEntryPermit(): IDocumentType {
        return this.FromId(295);
    }
    /**
        Returns DS2019 Exchange Visitor Certificate DocumentType
    **/
    get DS2019ExchangeVisitorCertificate(): IDocumentType {
        return this.FromId(296);
    }
    /**
        Returns Odometer Statement DocumentType
    **/
    get OdometerStatement(): IDocumentType {
        return this.FromId(297);
    }
    /**
        Returns Physical Inspection DocumentType
    **/
    get PhysicalInspection(): IDocumentType {
        return this.FromId(298);
    }
    /**
        Returns Government Document F-97 DocumentType
    **/
    get GovtDocumentF97(): IDocumentType {
        return this.FromId(299);
    }
    /**
        Returns Registration Penalty Fee Waiver Non-Use DocumentType
    **/
    get RegistrationPenaltyFeeWaiverNonUse(): IDocumentType {
        return this.FromId(300);
    }
    /**
        Returns Highway Use Certificate DocumentType
    **/
    get HighwayUseCertificate(): IDocumentType {
        return this.FromId(301);
    }
    /**
        Returns Neighborhood Electric Vehicle Form DocumentType
    **/
    get NeighborhoodElectricVehicleForm(): IDocumentType {
        return this.FromId(302);
    }
    /**
        Returns For Hire Certificate DocumentType
    **/
    get ForHireCertificate(): IDocumentType {
        return this.FromId(303);
    }
    /**
        Returns Transfer Order Excess Personal Property DocumentType
    **/
    get TransferOrderExcessPersonalProperty(): IDocumentType {
        return this.FromId(304);
    }
    /**
        Returns FP Off Highway Vehicle Decal Authorization DocumentType
    **/
    get OffHighwayVehicleDecalAuthorization(): IDocumentType {
        return this.FromId(305);
    }
    /**
        Returns Death Certificate DocumentType
    **/
    get DeathCertificate(): IDocumentType {
        return this.FromId(306);
    }
    /**
        Returns Vehicle Certificate of Title DocumentType
    **/
    get VehicleCertificateofTitle(): IDocumentType {
        return this.FromId(307);
    }
    /**
        Returns FP Vehicle Registration DocumentType
    **/
    get VehicleRegistration(): IDocumentType {
        return this.FromId(308);
    }
    /**
        Returns Dealer Invoice DocumentType
    **/
    get DealerInvoice(): IDocumentType {
        return this.FromId(309);
    }
    /**
        Returns Security Agreement DocumentType
    **/
    get SecurityAgreement(): IDocumentType {
        return this.FromId(310);
    }
    /**
        Returns Financial Institution Letter DocumentType
    **/
    get FinancialInstitutionLetter(): IDocumentType {
        return this.FromId(311);
    }
    /**
        Returns Lien Release DocumentType
    **/
    get LienRelease(): IDocumentType {
        return this.FromId(312);
    }
    /**
        Returns Lienholder Permission Letter DocumentType
    **/
    get LeinholderPermissionLetter(): IDocumentType {
        return this.FromId(313);
    }
    /**
        Returns Out Of State Repossession Affidavit DocumentType
    **/
    get OutOfStateRepossessionAffidavit(): IDocumentType {
        return this.FromId(314);
    }
    /**
        Returns Decree Of Distribution DocumentType
    **/
    get DecreeOfDistribution(): IDocumentType {
        return this.FromId(315);
    }
    /**
        Returns Appointment Of Trustee DocumentType
    **/
    get AppointmentOfTrustee(): IDocumentType {
        return this.FromId(316);
    }
    /**
        Returns Appointment Of Referee DocumentType
    **/
    get AppointmentOfReferee(): IDocumentType {
        return this.FromId(317);
    }
    /**
        Returns IRS Form 2435 DocumentType
    **/
    get IRSForm2435(): IDocumentType {
        return this.FromId(318);
    }
    /**
        Returns Bonded Title Requirements DocumentType
    **/
    get BondedTitleRequirements(): IDocumentType {
        return this.FromId(319);
    }
    /**
        Returns Bonded Title Affidavit DocumentType
    **/
    get BondedTitleAffidavit(): IDocumentType {
        return this.FromId(320);
    }
    /**
        Returns Credential Issuance Application DocumentType
    **/
    get CredentialIssuanceApplication(): IDocumentType {
        return this.FromId(321);
    }
    /**
        Returns Medical Exam Report DocumentType
    **/
    get MedicalExamReport(): IDocumentType {
        return this.FromId(322);
    }
    /**
        Returns Substance Abuse Evaluation DocumentType
    **/
    get SubstanceAbuseEvaluation(): IDocumentType {
        return this.FromId(323);
    }
    /**
        Returns Driver Condition/Behavior Report DocumentType
    **/
    get DriverConditionBehaviorReport(): IDocumentType {
        return this.FromId(324);
    }
    /**
        Returns Physician Exam Report DocumentType
    **/
    get PhysicianExamReport(): IDocumentType {
        return this.FromId(325);
    }
    /**
        Returns Law Enforcement Driver Behavior Report DocumentType
    **/
    get LEDriverBehaviorReport(): IDocumentType {
        return this.FromId(326);
    }
    /**
        Returns Arizona Title Summary DocumentType
    **/
    get AZTitleSummary(): IDocumentType {
        return this.FromId(327);
    }
    /**
        Returns Temp License Plate Temp Registration DocumentType
    **/
    get TempLicensePlateTempRegistration(): IDocumentType {
        return this.FromId(328);
    }
    /**
        Returns Vehicle Registration DocumentType
    **/
    get AZVehicleRegistration(): IDocumentType {
        return this.FromId(329);
    }
    /**
        Returns Interim Placard DocumentType
    **/
    get InterimPlacard(): IDocumentType {
        return this.FromId(330);
    }
    /**
        Returns Vehicle MVR DocumentType
    **/
    get VehicleMVR(): IDocumentType {
        return this.FromId(331);
    }
    /**
        Returns Motor Vehicle Record Artifact DocumentType
    **/
    get MotorVehicleRecordArtifact(): IDocumentType {
        return this.FromId(332);
    }
    /**
        Returns Current Tax Return DocumentType
    **/
    get TaxReturn(): IDocumentType {
        return this.FromId(333);
    }
    /**
        Returns SPE Certificate of Completion DocumentType
    **/
    get SPECertificateofCompletion(): IDocumentType {
        return this.FromId(334);
    }
    /**
        Returns CDL Medical Exam Certificate DocumentType
    **/
    get MedicalExamCertificate(): IDocumentType {
        return this.FromId(335);
    }
    /**
        Returns Guardianship Court Documents DocumentType
    **/
    get GuardianshipCourtDocuments(): IDocumentType {
        return this.FromId(336);
    }
    /**
        Returns FP Vehicle Registration Renewal Notice DocumentType
    **/
    get FormPortVehRegRenewalNotice(): IDocumentType {
        return this.FromId(337);
    }
    /**
        Returns Homeless Verification on Veteran's Administration Letterhead DocumentType
    **/
    get VAHomelessCertificationLetter(): IDocumentType {
        return this.FromId(338);
    }
    /**
        Returns Homeless Verification from a Verifiable Provider of Services DocumentType
    **/
    get VerifiableServiceProviderHomelessCertificationLetter(): IDocumentType {
        return this.FromId(339);
    }
    /**
        Returns DS-1972D (Dept of State DL Exam Form) DocumentType
    **/
    get DS1972D(): IDocumentType {
        return this.FromId(340);
    }
    /**
        Returns Dept of State Waiver DocumentType
    **/
    get DeptOfStateWaiver(): IDocumentType {
        return this.FromId(341);
    }
    /**
        Returns Invitational Travel Orders (ITO) DocumentType
    **/
    get InvitationalTravelOrders(): IDocumentType {
        return this.FromId(342);
    }
    /**
        Returns I-129 DocumentType
    **/
    get I129(): IDocumentType {
        return this.FromId(343);
    }
    /**
        Returns I-829 DocumentType
    **/
    get I829(): IDocumentType {
        return this.FromId(344);
    }
    /**
        Returns NATO Orders DocumentType
    **/
    get NATOOrders(): IDocumentType {
        return this.FromId(345);
    }
    /**
        Returns Official Certificate/Letter in lieu of Travel Orders DocumentType
    **/
    get OfficialCertificateLetter(): IDocumentType {
        return this.FromId(346);
    }
    /**
        Returns Non-Eligibility Letter from Dept of State Office of Foreign Missions DocumentType
    **/
    get NonEligibilityLetter(): IDocumentType {
        return this.FromId(347);
    }
    /**
        Returns Immigration Order granting Asylum DocumentType
    **/
    get ImmigrationOrder(): IDocumentType {
        return this.FromId(348);
    }
    /**
        Returns Refund Receipt DocumentType
    **/
    get RefundReceipt(): IDocumentType {
        return this.FromId(349);
    }
    /**
        Returns Payment Receipt DocumentType
    **/
    get PaymentReceipt(): IDocumentType {
        return this.FromId(350);
    }
    /**
        Returns AP Conversion - Other DocumentType
    **/
    get APConversionOther(): IDocumentType {
        return this.FromId(351);
    }
    /**
        Returns Unexpired Foreign Passport DocumentType
    **/
    get ForeignPassport(): IDocumentType {
        return this.FromId(352);
    }
    /**
        Returns IRS Form 2290 DocumentType
    **/
    get IRSForm2290(): IDocumentType {
        return this.FromId(353);
    }
    /**
        Returns Notice to Provider Form DocumentType
    **/
    get NoticeProviderForm(): IDocumentType {
        return this.FromId(354);
    }
    /**
        Returns Correspondence DocumentType
    **/
    get Correspondence(): IDocumentType {
        return this.FromId(355);
    }
    /**
        Returns Temporary Credential for DL or Permit 21 and Older DocumentType
    **/
    get TempCredDLPermit21Older(): IDocumentType {
        return this.FromId(356);
    }
    /**
        Returns Temporary Credential for DL or Permit Under 21 DocumentType
    **/
    get TempCredDLPermitUnder21(): IDocumentType {
        return this.FromId(357);
    }
    /**
        Returns Temporary Credential CDL or CLP 21 and Older DocumentType
    **/
    get TempCredCDL21Older(): IDocumentType {
        return this.FromId(358);
    }
    /**
        Returns Temporary Credential CDL or CLP Under 21 DocumentType
    **/
    get TempCredCDLUnder21(): IDocumentType {
        return this.FromId(359);
    }
    /**
        Returns Temporary Credential ID 21 and Older DocumentType
    **/
    get TempCredID21Older(): IDocumentType {
        return this.FromId(360);
    }
    /**
        Returns Temporary Credential ID Under 21 DocumentType
    **/
    get TempCredIDUnder21(): IDocumentType {
        return this.FromId(361);
    }
    /**
        Returns I-797 Notice of Action DocumentType
    **/
    get I797(): IDocumentType {
        return this.FromId(362);
    }
    /**
        Returns SSA Referral  Letter DocumentType
    **/
    get SSAReferral(): IDocumentType {
        return this.FromId(363);
    }
    /**
        Returns I 688 Temporary Resident Card DocumentType
    **/
    get I688TemporaryResidentCard(): IDocumentType {
        return this.FromId(364);
    }
    /**
        Returns Use Fuel Vendor Refund Application DocumentType
    **/
    get VendorRefund(): IDocumentType {
        return this.FromId(365);
    }
    /**
        Returns Invoices/Receipts DocumentType
    **/
    get InvoicesReceipts(): IDocumentType {
        return this.FromId(366);
    }
    /**
        Returns Foreign-Based IFTA Tax Credit Refund Application DocumentType
    **/
    get ForeignIFTARefund(): IDocumentType {
        return this.FromId(367);
    }
    /**
        Returns IFTA Quarterly Tax Report DocumentType
    **/
    get IFTAQuarterly(): IDocumentType {
        return this.FromId(368);
    }
    /**
        Returns IFTA License DocumentType
    **/
    get IFTALicense(): IDocumentType {
        return this.FromId(369);
    }
    /**
        Returns Arizona-Based IFTA Fuel Tax Refund Application DocumentType
    **/
    get ArizonaIFTARefund(): IDocumentType {
        return this.FromId(370);
    }
    /**
        Returns IFTA Tax Filing DocumentType
    **/
    get IFTATaxFiling(): IDocumentType {
        return this.FromId(371);
    }
    /**
        Returns Tribal Member Refund Application DocumentType
    **/
    get TribalRefund(): IDocumentType {
        return this.FromId(372);
    }
    /**
        Returns Tribal Enrollment Card DocumentType
    **/
    get TribalEnrollment(): IDocumentType {
        return this.FromId(373);
    }
    /**
        Returns Tribal Government Refund Application DocumentType
    **/
    get TribalGovRefund(): IDocumentType {
        return this.FromId(374);
    }
    /**
        Returns Exporter Refund Application DocumentType
    **/
    get ExporterRefund(): IDocumentType {
        return this.FromId(375);
    }
    /**
        Returns Purchase Invoices DocumentType
    **/
    get PurchaseInvoices(): IDocumentType {
        return this.FromId(376);
    }
    /**
        Returns Sales Invoices DocumentType
    **/
    get SalesInvoices(): IDocumentType {
        return this.FromId(377);
    }
    /**
        Returns Bill of Lading DocumentType
    **/
    get BillOfLading(): IDocumentType {
        return this.FromId(378);
    }
    /**
        Returns Export State(s) Fuel Tax Report DocumentType
    **/
    get ExportFTReport(): IDocumentType {
        return this.FromId(379);
    }
    /**
        Returns Motor Vehicle Fuel Refund Application DocumentType
    **/
    get MVFRefund(): IDocumentType {
        return this.FromId(380);
    }
    /**
        Returns Equipment List DocumentType
    **/
    get EquipmentList(): IDocumentType {
        return this.FromId(381);
    }
    /**
        Returns Flight Log DocumentType
    **/
    get FlightLog(): IDocumentType {
        return this.FromId(382);
    }
    /**
        Returns Forest Products Use Fuel Refund Application DocumentType
    **/
    get ForestRefund(): IDocumentType {
        return this.FromId(383);
    }
    /**
        Returns Arizona Commerce Authority Certification Letter DocumentType
    **/
    get AZCommerce(): IDocumentType {
        return this.FromId(384);
    }
    /**
        Returns Use Fuel Refund Application DocumentType
    **/
    get UseFuelRefund(): IDocumentType {
        return this.FromId(385);
    }
    /**
        Returns Summary Schedules DocumentType
    **/
    get SummarySchedules(): IDocumentType {
        return this.FromId(386);
    }
    /**
        Returns Bulk Fuel Inventory Reconciliation DocumentType
    **/
    get BulkFuelRecon(): IDocumentType {
        return this.FromId(387);
    }
    /**
        Returns Contaminated Fuel Refund Application DocumentType
    **/
    get ContaminatedFuelRefund(): IDocumentType {
        return this.FromId(388);
    }
    /**
        Returns Letters/Documentation of Explanation of Loss DocumentType
    **/
    get ExplanationOfLoss(): IDocumentType {
        return this.FromId(389);
    }
    /**
        Returns FP Report Out Of State Convictions DocumentType
    **/
    get ReportOOSConvictions(): IDocumentType {
        return this.FromId(390);
    }
    /**
        Returns Report Out Of State Withdrawals DocumentType
    **/
    get ReportOOSWithdrawals(): IDocumentType {
        return this.FromId(391);
    }
    /**
        Returns Aviation Fuel Refund Application DocumentType
    **/
    get AviationRefund(): IDocumentType {
        return this.FromId(392);
    }
    /**
        Returns Tribal Retailer Application DocumentType
    **/
    get TribalRetailerApplication(): IDocumentType {
        return this.FromId(393);
    }
    /**
        Returns Transactional Report DocumentType
    **/
    get TransactionalReport(): IDocumentType {
        return this.FromId(394);
    }
    /**
        Returns FP Medical Eligibility Expiration DocumentType
    **/
    get FormPortMedicalEligibilityExpiration(): IDocumentType {
        return this.FromId(395);
    }
    /**
        Returns Medical Eligibility Expiration DocumentType
    **/
    get MedicalEligibilityExpiration(): IDocumentType {
        return this.FromId(396);
    }
    /**
        Returns Refund Request Application DocumentType
    **/
    get RefundRequestApplication(): IDocumentType {
        return this.FromId(397);
    }
    /**
        Returns FP Driver License Medical Eligibility Notice DocumentType
    **/
    get FormPortDriverLicenseMedicalEligibilityNotice(): IDocumentType {
        return this.FromId(398);
    }
    /**
        Returns FP Vision Review Reminder DocumentType
    **/
    get FormPortVisionReviewReminder(): IDocumentType {
        return this.FromId(399);
    }
    /**
        Returns FP Additional Requirements DocumentType
    **/
    get FormPortAdditionalRequirement(): IDocumentType {
        return this.FromId(400);
    }
    /**
        Returns FP Driver License Medical Review Notice DocumentType
    **/
    get FormPortDLMedReviewNotice(): IDocumentType {
        return this.FromId(401);
    }
    /**
        Returns Driver License Medical Review Notice DocumentType
    **/
    get DLMedReviewNotice(): IDocumentType {
        return this.FromId(402);
    }
    /**
        Returns FP Photo Expiration Notice DocumentType
    **/
    get FormPortPhotoExpireNotice(): IDocumentType {
        return this.FromId(403);
    }
    /**
        Returns Photo Expiration Notice DocumentType
    **/
    get PhotoExpireNotice(): IDocumentType {
        return this.FromId(404);
    }
    /**
        Returns FP Non Resident Violator Compact Conviction Notice DocumentType
    **/
    get FormPortNonResidentViolatorCompactConvictionNotice(): IDocumentType {
        return this.FromId(405);
    }
    /**
        Returns FP CDL Waiver Expiration Notice DocumentType
    **/
    get FormPortCDLWaiverExpirationNotice(): IDocumentType {
        return this.FromId(406);
    }
    /**
        Returns FP Hazmat Renewal DocumentType
    **/
    get FormPortHazmatRenewal(): IDocumentType {
        return this.FromId(407);
    }
    /**
        Returns CDL Waiver Expiration Notice DocumentType
    **/
    get CDLWaiverExpirationNotice(): IDocumentType {
        return this.FromId(408);
    }
    /**
        Returns Hazmat Renewal DocumentType
    **/
    get HazmatRenewal(): IDocumentType {
        return this.FromId(409);
    }
    /**
        Returns WithdrawalNoticeNoHearing DocumentType
    **/
    get WithdrawalNoticeNoHearing(): IDocumentType {
        return this.FromId(410);
    }
    /**
        Returns WithdrawalNoticeWithHearing DocumentType
    **/
    get WithdrawalNoticeWithHearing(): IDocumentType {
        return this.FromId(411);
    }
    /**
        Returns FP Uhaul Vehicle Title DocumentType
    **/
    get FormPortUhaulVehTitle(): IDocumentType {
        return this.FromId(413);
    }
    /**
        Returns Miscellaneous Document DocumentType
    **/
    get MiscellaneousDoc(): IDocumentType {
        return this.FromId(414);
    }
    /**
        Returns FP Abandoned Vehicle Notice DocumentType
    **/
    get AbandonedVehicleNotice(): IDocumentType {
        return this.FromId(415);
    }
    /**
        Returns Abandoned Vehicle Notice Out of State DocumentType
    **/
    get AbandonedVehicleNoticeOutOfState(): IDocumentType {
        return this.FromId(416);
    }
    /**
        Returns FP Authorization for Transfer of Ownership DocumentType
    **/
    get AuthorizationForTransferOfOwnership(): IDocumentType {
        return this.FromId(417);
    }
    /**
        Returns FP Authorization To Junk Vehicle DocumentType
    **/
    get CrushCertificate(): IDocumentType {
        return this.FromId(418);
    }
    /**
        Returns Emissions Compliance Notification DocumentType
    **/
    get EmissionsComplianceNotification(): IDocumentType {
        return this.FromId(419);
    }
    /**
        Returns FP Emissions Compliance Notification DocumentType
    **/
    get FormPortEmissionsComplianceNotification(): IDocumentType {
        return this.FromId(420);
    }
    /**
        Returns Insurance Suspension Notification DocumentType
    **/
    get InsuranceSuspensionNotification(): IDocumentType {
        return this.FromId(421);
    }
    /**
        Returns FP Insurance Suspension Notification DocumentType
    **/
    get FormPortInsuranceSuspensionNotification(): IDocumentType {
        return this.FromId(422);
    }
    /**
        Returns Electronic Title Notification DocumentType
    **/
    get ElectronicTitleNotification(): IDocumentType {
        return this.FromId(423);
    }
    /**
        Returns FP Electronic Title Notification DocumentType
    **/
    get FormPortElectronicTitleNotification(): IDocumentType {
        return this.FromId(424);
    }
    /**
        Returns WithdrawalNoticeWithHearingAdminAction DocumentType
    **/
    get WithdrawalNoticeAdministrativeAction(): IDocumentType {
        return this.FromId(425);
    }
    /**
        Returns Notice of Restriction  DocumentType
    **/
    get NoticeofRestriction(): IDocumentType {
        return this.FromId(426);
    }
    /**
        Returns EDUI Error Report DocumentType
    **/
    get EDUIErrorReport(): IDocumentType {
        return this.FromId(427);
    }
    /**
        Returns Buyer eTitle Transfer DocumentType
    **/
    get BuyerETitleTransfer(): IDocumentType {
        return this.FromId(428);
    }
    /**
        Returns FP Withdrawal Notice No Hearing DocumentType
    **/
    get FormPortWithdrawalNoticeNoHearing(): IDocumentType {
        return this.FromId(429);
    }
    /**
        Returns FP Withdrawal Notice With Hearing DocumentType
    **/
    get FormPortWithdrawalNoticeWithHearing(): IDocumentType {
        return this.FromId(430);
    }
    /**
        Returns FP Driver Notice DocumentType
    **/
    get FPDriverNotice(): IDocumentType {
        return this.FromId(431);
    }
    /**
        Returns Driver Notice DocumentType
    **/
    get DriverNotice(): IDocumentType {
        return this.FromId(432);
    }
    /**
        Returns FP Report OOS Withdrawals DocumentType
    **/
    get FormPortReportOOSWithdrawals(): IDocumentType {
        return this.FromId(433);
    }
    /**
        Returns FP Fleet Renewal Notice DocumentType
    **/
    get FormPortFleetRenewalNotice(): IDocumentType {
        return this.FromId(434);
    }
    /**
        Returns Temporary Credential DocumentType
    **/
    get TempCredential(): IDocumentType {
        return this.FromId(435);
    }
    /**
        Returns Voter Registration Receipt DocumentType
    **/
    get VoterRegistrationReceipt(): IDocumentType {
        return this.FromId(436);
    }
    /**
        Returns Vehicle Registration Plate Fulfillment DocumentType
    **/
    get VehicleRegistrationFulfillment(): IDocumentType {
        return this.FromId(437);
    }
    /**
        Returns FP Temporary Disability Placard DocumentType
    **/
    get FormPortTempPlacard(): IDocumentType {
        return this.FromId(439);
    }
    /**
        Returns FP Permanent Disability Placard DocumentType
    **/
    get FormPortPermPlacard(): IDocumentType {
        return this.FromId(440);
    }
    /**
        Returns Vehicle Title Shell DocumentType
    **/
    get VehicleTitleShell(): IDocumentType {
        return this.FromId(441);
    }
    /**
        Returns Signed Arizona Title Summary DocumentType
    **/
    get SignedAZTitleSummary(): IDocumentType {
        return this.FromId(442);
    }
    /**
        Returns Transfer Receipt DocumentType
    **/
    get TransferReceipt(): IDocumentType {
        return this.FromId(443);
    }
    /**
        Returns Scan Later Cover Letter DocumentType
    **/
    get ScanLaterCoverLetter(): IDocumentType {
        return this.FromId(1290);
    }
    /**
        Returns FP Withdrawal Notice Administrative Action DocumentType
    **/
    get FormPortWithdrawalNoticeAdministrativeAction(): IDocumentType {
        return this.FromId(1291);
    }
    /**
        Returns Withdrawal Notice Law Enforcement Affidavit No Hearing DocumentType
    **/
    get WithdrawalNoticeLawEnforcementAffidavitNoHearing(): IDocumentType {
        return this.FromId(1292);
    }
    /**
        Returns FP Withdrawal Notice Law Enforcement Affidavit No Hearing DocumentType
    **/
    get FormPortWithdrawalLawEnforcementAffidavitNoHearing(): IDocumentType {
        return this.FromId(1293);
    }
    /**
        Returns Withdrawal Notice Law Enforcement Affidavit with Hearing DocumentType
    **/
    get WithdrawalNoticeLawEnforcementAffidavitWithHearing(): IDocumentType {
        return this.FromId(1294);
    }
    /**
        Returns FP Withdrawal Law Enforcement Affidavit with Hearing DocumentType
    **/
    get FormPortWithdrawalLawEnforcementAffidavitWithHearing(): IDocumentType {
        return this.FromId(1295);
    }
    /**
        Returns Restricted License Eligibility Notice DocumentType
    **/
    get RestrictedLicenseEligibilityNotice(): IDocumentType {
        return this.FromId(1296);
    }
    /**
        Returns FP Restricted License Eligibility Notice DocumentType
    **/
    get FormPortRestrictedLicenseEligibilityNotice(): IDocumentType {
        return this.FromId(1297);
    }
    /**
        Returns IID Extension Notice With Hearing DocumentType
    **/
    get IIDExtensionNoticewithWithHearing(): IDocumentType {
        return this.FromId(1298);
    }
    /**
        Returns FP IID Extension Notice With Hearing DocumentType
    **/
    get FormPortIIDExtensionNoticeWithHearing(): IDocumentType {
        return this.FromId(1299);
    }
    /**
        Returns NSF Notice DocumentType
    **/
    get NSFNotice(): IDocumentType {
        return this.FromId(1300);
    }
    /**
        Returns FP NSF Notice DocumentType
    **/
    get FormPortNSFNotice(): IDocumentType {
        return this.FromId(1301);
    }
    /**
        Returns Credentials Cancelled Notice DocumentType
    **/
    get CredentialsCancelledNotice(): IDocumentType {
        return this.FromId(1302);
    }
    /**
        Returns FP Credentials Cancelled Notice DocumentType
    **/
    get FormPortCredentialsCancelledNotice(): IDocumentType {
        return this.FromId(1303);
    }
    /**
        Returns IID Extension Notice No Hearing DocumentType
    **/
    get IIDExtensionNoticeNoHearing(): IDocumentType {
        return this.FromId(1304);
    }
    /**
        Returns FP IID Extension Notice No Hearing DocumentType
    **/
    get FormPortIIDExtensionNoticeNoHearing(): IDocumentType {
        return this.FromId(1305);
    }
    /**
        Returns Returned Mail DocumentType
    **/
    get ReturnedMail(): IDocumentType {
        return this.FromId(1306);
    }
    /**
        Returns AZ Issued DL DocumentType
    **/
    get AZIssuedDL(): IDocumentType {
        return this.FromId(1307);
    }
    /**
        Returns Notice of Action DocumentType
    **/
    get NoticeOfAction(): IDocumentType {
        return this.FromId(1308);
    }
    /**
        Returns Foreign Birth Certificate DocumentType
    **/
    get ForeignBirthCertificate(): IDocumentType {
        return this.FromId(1309);
    }
    /**
        Returns Unexpired Foreign Driver License DocumentType
    **/
    get UnexpiredForeignDriverLicense(): IDocumentType {
        return this.FromId(1310);
    }
    /**
        Returns IRP-IFTA DocumentType
    **/
    get IRPIFTA(): IDocumentType {
        return this.FromId(1311);
    }
    /**
        Returns Court Paper Abstracts DocumentType
    **/
    get CourtPaperAbstracts(): IDocumentType {
        return this.FromId(1312);
    }
    /**
        Returns Law Enforcement Affidavit DocumentType
    **/
    get LawEnforcementAffidavit(): IDocumentType {
        return this.FromId(1313);
    }
    /**
        Returns Hazmat Endorsement Cancellation Notice DocumentType
    **/
    get HazmatEndorsementCancellationNotice(): IDocumentType {
        return this.FromId(1314);
    }
    /**
        Returns FP Hazmat Endorsement Cancellation Notice DocumentType
    **/
    get FormPortHazmatEndorsementCancellationNotice(): IDocumentType {
        return this.FromId(1315);
    }
    /**
        Returns FP Vehicle Registration Condition Notice DocumentType
    **/
    get FormPortWithdrawalNoticeVehicleRegistrationConditionNotice(): IDocumentType {
        return this.FromId(1316);
    }
    /**
        Returns Vehicle Registration Condition Notice DocumentType
    **/
    get WithdrawalNoticeVehicleRegistationConditionNotice(): IDocumentType {
        return this.FromId(1317);
    }
    /**
        Returns Substance Abuse Evaluation Order DocumentType
    **/
    get SubstanceAbuseEvaluationOrder(): IDocumentType {
        return this.FromId(1318);
    }
    /**
        Returns Ignition Interlock Deferment Eligible Notice DocumentType
    **/
    get IgnitionInterlockDefermentEligibleNotice(): IDocumentType {
        return this.FromId(1319);
    }
    /**
        Returns FP Ignition Interlock Deferment Eligible Notice DocumentType
    **/
    get FormPortIgnitionInterlockDefermentEligibleNotice(): IDocumentType {
        return this.FromId(1320);
    }
    /**
        Returns Ignition Interlock Deferment DocumentType
    **/
    get IgnitionInterlockDeferment(): IDocumentType {
        return this.FromId(1321);
    }
    /**
        Returns FP Ignition Interlock Deferment DocumentType
    **/
    get FormPortIgnitionInterlockDeferment(): IDocumentType {
        return this.FromId(1322);
    }
    /**
        Returns Stay Letter DocumentType
    **/
    get StayLetter(): IDocumentType {
        return this.FromId(1323);
    }
    /**
        Returns Stay Letter Summary DocumentType
    **/
    get StayLetterSummary(): IDocumentType {
        return this.FromId(1324);
    }
    /**
        Returns FP Stay Letter DocumentType
    **/
    get FormPortStayLetter(): IDocumentType {
        return this.FromId(1325);
    }
    /**
        Returns FP Stay Letter Summary DocumentType
    **/
    get FormPortStayLetterSummary(): IDocumentType {
        return this.FromId(1326);
    }
    /**
        Returns Written Consent Judgement DocumentType
    **/
    get WrittenConsentJudgement(): IDocumentType {
        return this.FromId(1327);
    }
    /**
        Returns Revoked Consent Judgement DocumentType
    **/
    get RevokedConsentJudgement(): IDocumentType {
        return this.FromId(1328);
    }
    /**
        Returns Renewal of Judgement DocumentType
    **/
    get RenewalOfJudgement(): IDocumentType {
        return this.FromId(1329);
    }
    /**
        Returns Non Renewal of Judgement DocumentType
    **/
    get NonRenewalOfJudgement(): IDocumentType {
        return this.FromId(1330);
    }
    /**
        Returns Satisfaction - Foreign Satisfaction DocumentType
    **/
    get SatisfactionForeignSatisfaction(): IDocumentType {
        return this.FromId(1331);
    }
    /**
        Returns Set Aside Judgement DocumentType
    **/
    get SetAsideJudgement(): IDocumentType {
        return this.FromId(1332);
    }
    /**
        Returns Vacate Void Dismissal Judgement DocumentType
    **/
    get VacateVoidDismissalJudgement(): IDocumentType {
        return this.FromId(1333);
    }
    /**
        Returns Petition To Reinstate DocumentType
    **/
    get PetitionToReinstate(): IDocumentType {
        return this.FromId(1334);
    }
    /**
        Returns Stipulation Petition Approved DocumentType
    **/
    get StipulationPetitionApproved(): IDocumentType {
        return this.FromId(1335);
    }
    /**
        Returns Final Discharge Bankruptcy DocumentType
    **/
    get FinalDischargeBancruptcy(): IDocumentType {
        return this.FromId(1336);
    }
    /**
        Returns Arizona Travel ID DocumentType
    **/
    get ArizonaTravelID(): IDocumentType {
        return this.FromId(1337);
    }
    /**
        Returns Arizona Travel CDL DocumentType
    **/
    get ArizonaTravelCDL(): IDocumentType {
        return this.FromId(1338);
    }
    /**
        Returns Arizona Travel Motorcycle DocumentType
    **/
    get ArizonaTravelMotorcycle(): IDocumentType {
        return this.FromId(1339);
    }
    /**
        Returns Arizona Travel DL DocumentType
    **/
    get ArizonaTravelDL(): IDocumentType {
        return this.FromId(1340);
    }
    /**
        Returns Arizona ID DocumentType
    **/
    get ArizonaID(): IDocumentType {
        return this.FromId(1341);
    }
    /**
        Returns Arizona CDL DocumentType
    **/
    get ArizonaCDL(): IDocumentType {
        return this.FromId(1342);
    }
    /**
        Returns Arizona Motorcycle DocumentType
    **/
    get ArizonaMotorcycle(): IDocumentType {
        return this.FromId(1343);
    }
    /**
        Returns Arizona DL DocumentType
    **/
    get ArizonaDL(): IDocumentType {
        return this.FromId(1344);
    }
    /**
        Returns All Title Documents DocumentType
    **/
    get AllTitleDocuments(): IDocumentType {
        return this.FromId(2303);
    }
    /**
        Returns FP Towed Vehicle DocumentType
    **/
    get TowedVehicle(): IDocumentType {
        return this.FromId(2304);
    }
    /**
        Returns EHO Decision and Order DocumentType
    **/
    get EHODecisionAndOrder(): IDocumentType {
        return this.FromId(2311);
    }
    /**
        Returns FP Order of Suspension/Cancellation Fraud DocumentType
    **/
    get FPOrderofSuspensionCancellationFraud(): IDocumentType {
        return this.FromId(2317);
    }
    /**
        Returns Order of Suspension/Cancellation Fraud DocumentType
    **/
    get OrderofSuspensionCancellationFraud(): IDocumentType {
        return this.FromId(2318);
    }
    /**
        Returns Owner Affidavit Sale DocumentType
    **/
    get OwnerAffidavitSale(): IDocumentType {
        return this.FromId(2319);
    }
    /**
        Returns TSS Assignments No Hearing DocumentType
    **/
    get TSSAssignmentsNoHearing(): IDocumentType {
        return this.FromId(2322);
    }
    /**
        Returns TSS Assignments With Hearing DocumentType
    **/
    get TSSAssignmentsWithHearing(): IDocumentType {
        return this.FromId(2323);
    }
    /**
        Returns Fleet Renewal Invite DocumentType
    **/
    get FleetRenewalInvite(): IDocumentType {
        return this.FromId(2324);
    }
    /**
        Returns FP Non Resident Violation Compact Clear Notice DocumentType
    **/
    get FPNonResidentViolationCompactClearNotice(): IDocumentType {
        return this.FromId(2326);
    }
    /**
        Returns CDL Waiver Documents For MRP Staff Only DocumentType
    **/
    get CDLWaiverDocuments(): IDocumentType {
        return this.FromId(2331);
    }
    /**
        Returns FMS Billing Notification DocumentType
    **/
    get FMSBillingNotification(): IDocumentType {
        return this.FromId(2332);
    }
    /**
        Returns FP FMS Billing Notification DocumentType
    **/
    get FPFMSBillingNotification(): IDocumentType {
        return this.FromId(2333);
    }
    /**
        Returns MVD Compliance Required DocumentType
    **/
    get MVDComplianceRequired(): IDocumentType {
        return this.FromId(2334);
    }
    /**
		Returns Window Tint Medical Exemption Application DocumentType
	**/
    get WindowTintApplication(): IDocumentType {
        return this.FromId(2335);
    }
    /**
		Returns Other Document With an I-94 number DocumentType
	**/
    get OtherDocumentWithI94(): IDocumentType {
        return this.FromId(2352);
    }
    /**
		Returns Other Document With an I-94 number DocumentType
	**/
    get OtherDocumentWithANumber(): IDocumentType {
        return this.FromId(2353);
    }
    /**
		Returns Other Document MC Proof Name Address Change
	**/
    get MCProofNameAddressChange(): IDocumentType {
        return this.FromId(2378);
    }
    /**
		Returns Fleet Vehicle Credit DocumentType
	**/
    get FleetVehicleCredit(): IDocumentType {
        return this.FromId(2435);
    }
    /**
        Returns Agreement and Exhibits DocumentType
    **/
    get AgreementExhibits(): IDocumentType {
        return this.FromId(2439);
    }
    /**
        Returns Joint Letter of Renewal DocumentType
    **/
    get LetterOfRenewal(): IDocumentType {
        return this.FromId(2440);
    }
    /**
        Returns Exhibit A Title and Registration Authorized Activities DocumentType
    **/
    get ExhibitATitleAndRegistrationAuthorizedActivities(): IDocumentType {
        return this.FromId(2506);
    }
    /**
        Returns Exhibit B Only for Companies with Branch Locations DocumentType
    **/
    get ExhibitBOnlyForCompaniesWithBranchLocations(): IDocumentType {
        return this.FromId(2507);
    }
    /**
        Returns Exhibit C Insurance and Bonding Requirements DocumentType
    **/
    get ExhibitCInsuranceAndBondingRequirements(): IDocumentType {
        return this.FromId(2508);
    }
    /**
        Returns Exhibit D Performance Measurements DocumentType
    **/
    get ExhibitDPerformanceMeasurements(): IDocumentType {
        return this.FromId(2509);
    }
    /**
        Returns Exhibit E Non-Discrimination DocumentType
    **/
    get ExhibitENonDiscrimination(): IDocumentType {
        return this.FromId(2510);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('2293', { id: 2293, value: 'AVIS Title', formNumber: 'A48-7200', displayValue: 'FP AVIS Title', description: 'AVIS Title', active: true, sortOrder: 1 });
        this._dictionary.add('2294', { id: 2294, value: 'AADA Title', formNumber: 'AA48-7200', displayValue: 'AADA Title', description: 'AADA Title', active: true, sortOrder: 1 });
        this._dictionary.add('2295', { id: 2295, value: 'Enterprise Title', formNumber: 'E48-7200', displayValue: 'FP Enterprise Title', description: 'Enterprise Title', active: true, sortOrder: 1 });
        this._dictionary.add('2296', { id: 2296, value: 'Enterprise Registration', formNumber: 'E96-0365D', displayValue: 'FP Enterprise Registration and Tab', description: 'Enterprise Registration', active: true, sortOrder: 1 });
        this._dictionary.add('2297', { id: 2297, value: 'AADA Registration', formNumber: 'AA96-0365', displayValue: 'AADA Registration', description: 'AADA Registration', active: true, sortOrder: 1 });
        this._dictionary.add('2300', { id: 2300, value: 'LECU Registration', formNumber: 'L96-0365D', displayValue: 'FP ECD Registration and Tab', description: 'LECU Registration', active: true, sortOrder: 1 });
        this._dictionary.add('2305', { id: 2305, value: 'CustomerDocument', formNumber: '', displayValue: 'Customer Document', description: 'Customer Document', active: true, sortOrder: 1 });
        this._dictionary.add('2308', { id: 2308, value: 'Special Projects IT Registration', formNumber: 'S96-0365D', displayValue: 'FP Special Projects IT Registration', description: 'Special Projects IT Registration', active: true, sortOrder: 1 });
        this._dictionary.add('2309', { id: 2309, value: 'Special Projects IT Off Highway', formNumber: 'S96-0571', displayValue: 'FP Special Projects IT Off Highway', description: 'Special Projects IT Off Highway', active: true, sortOrder: 1 });
        this._dictionary.add('2310', { id: 2310, value: 'Special Projects IT Vehicle Title', formNumber: 'S48-7200M', displayValue: 'FP Special Projects IT Vehicle Title', description: 'Special Projects IT Vehicle Title', active: true, sortOrder: 1 });
        this._dictionary.add('2312', { id: 2312, value: '90DayNonResidentPermitAffidavit', formNumber: '', displayValue: 'Affidavit for 90 Day Non-Resident Permit', description: 'Affidavit for 90 Day Non-Resident Permit', active: true, sortOrder: 1 });
        this._dictionary.add('2313', { id: 2313, value: 'RenewRegistrationOverageNotice', formNumber: '15-1051', displayValue: 'FP Renew Registration Overage Notice', description: 'Renew Registration Overage Notice', active: true, sortOrder: 1 });
        this._dictionary.add('152', { id: 152, value: 'U.S.BirthCertificateorBirthAbroad', formNumber: '', displayValue: 'U.S. Birth Certificate or Birth Abroad', description: 'Original or Certified Copy of US Birth Certificate or  Birth Abroad', active: true, sortOrder: 10 });
        this._dictionary.add('156', { id: 156, value: 'USPassport/PassportCard', formNumber: '', displayValue: 'US Passport/ Passport Card', description: 'U.S. Passport or U.S.Passport Card', active: true, sortOrder: 20 });
        this._dictionary.add('157', { id: 157, value: 'ExpiredUSPassport/PassportCard', formNumber: '', displayValue: 'Expired US Passport/ Passport Card', description: 'Expired U.S. Passport or U.S. Passport Card', active: true, sortOrder: 30 });
        this._dictionary.add('179', { id: 179, value: 'REALIDDL', formNumber: '', displayValue: 'REAL ID DL', description: 'REAL ID driver\'s license ', active: true, sortOrder: 40 });
        this._dictionary.add('231', { id: 231, value: 'OOSDL', formNumber: '', displayValue: 'OOS DL', description: 'Driver License issued by any state, territory or possession of the U.S.', active: true, sortOrder: 50 });
        this._dictionary.add('162', { id: 162, value: 'I-94(Arrival/DepartureRecord)inUnexpiredForeignPassport', formNumber: '', displayValue: 'I-94 (Arrival/Departure Record) in Unexpired Foreign Passport', description: 'I-94 (Arrival/Departure Record) in Unexpired Foreign Passport', active: true, sortOrder: 60 });
        this._dictionary.add('164', { id: 164, value: 'I-94withphoto', formNumber: 'I-94', displayValue: 'I-94 with photo', description: 'I-94 Form with Photo, presented without passport. ', active: true, sortOrder: 70 });
        this._dictionary.add('160', { id: 160, value: 'I-551', formNumber: 'I-551', displayValue: 'I-551 Permanent Resident Card ', description: 'Valid, unexpired Permanent Residency Card or Resident Alien Card (I-551)', active: true, sortOrder: 80 });
        this._dictionary.add('161', { id: 161, value: 'ExpiredI-551', formNumber: 'I-551', displayValue: 'Expired I-551 Permanent Resident Card', description: 'Expired Permanent Residency Card or Resident Alien Card (I-551)', active: true, sortOrder: 90 });
        this._dictionary.add('167', { id: 167, value: 'EAC', formNumber: '', displayValue: 'Employment Authorization Card', description: 'USCIS Employment Authorization Card (EAC)_(Category A11 & C14 not allowed)', active: true, sortOrder: 100 });
        this._dictionary.add('211', { id: 211, value: 'UtilityBill', formNumber: '', displayValue: 'Utility Bill', description: 'Utility Bill - Water, Sewer, gas, Electricity, Cable, Internet, Phone, HOA or Garbage ', active: true, sortOrder: 110 });
        this._dictionary.add('209', { id: 209, value: 'PropertyDeed,MonthlyMortgagestatement/paymentbooklet,leaseagreement', formNumber: '', displayValue: 'Property Deed, Monthly Mortgage statement/payment booklet, lease agreement', description: 'Property Deed, Monthly Mortgage statement or payment booklet, lease agreement', active: true, sortOrder: 120 });
        this._dictionary.add('202', { id: 202, value: 'NameChangeDecree', formNumber: '', displayValue: 'Name Change Decree', description: 'Name Change Decree', active: true, sortOrder: 130 });
        this._dictionary.add('195', { id: 195, value: 'U.S(orterritory)MarriageCertificate', formNumber: '', displayValue: 'U.S (or territory) Marriage Certificate ', description: 'U.S (or territory) Marriage Certificate ', active: true, sortOrder: 140 });
        this._dictionary.add('199', { id: 199, value: 'DivorceDecree', formNumber: '', displayValue: 'Divorce Decree', description: 'Divorce Decree', active: true, sortOrder: 150 });
        this._dictionary.add('230', { id: 230, value: 'AmendedBirthCertificate', formNumber: '', displayValue: 'Amended Birth Certificate', description: 'A corrected Birth Certificate', active: true, sortOrder: 160 });
        this._dictionary.add('215', { id: 215, value: 'Bank/CreditCardStatement', formNumber: '', displayValue: 'Bank/Credit Card Statement', description: 'Mail from Financial Institution: Checking, Savings, Investment Account and Credit Card Statements dated 30 days from Date of Application', active: true, sortOrder: 170 });
        this._dictionary.add('216', { id: 216, value: 'MailfromGovernmentAgency', formNumber: '', displayValue: 'Mail from Government Agency', description: 'Mail from a Federal, State, City, County Government Agency Dated within 30 days of Application', active: true, sortOrder: 180 });
        this._dictionary.add('213', { id: 213, value: 'Homeowner/RenterInsurance', formNumber: '', displayValue: 'Homeowner/Renter Insurance', description: 'Current Homeowner or Renters Insurance Policy or Insurance Statement ', active: true, sortOrder: 190 });
        this._dictionary.add('2301', { id: 2301, value: 'Dealer Acquisition Contract', formNumber: '', displayValue: 'Dealer Acquisition Contract', description: 'Dealer Acquisition Contract', active: true, sortOrder: 999 });
        this._dictionary.add('2302', { id: 2302, value: 'Dealer Reassignment Form', formNumber: '', displayValue: 'Dealer Reassignment Form', description: 'Dealer Reassignment Form', active: true, sortOrder: 999 });
        this._dictionary.add('2292', { id: 2292, value: 'AVIS Vehicle Registration', formNumber: 'A96-0365D', displayValue: 'FP AVIS Registration and Tab', description: 'AVIS Vehicle Registration', active: true, sortOrder: 9999 });
        this._dictionary.add('2306', { id: 2306, value: 'UHaul Title', formNumber: 'U48-7200', displayValue: 'FP UHaul Title', description: 'FP UHaul Title', active: true, sortOrder: 9999 });
        this._dictionary.add('2315', { id: 2315, value: 'FPLitterLetter', formNumber: '23-3000', displayValue: 'FP Litter Letter', description: 'FormPort Litter Letter', active: true, sortOrder: 9999 });
        this._dictionary.add('2320', { id: 2320, value: 'FP IID Deferment Revoked Notice', formNumber: '96-0629', displayValue: 'FP IID Deferment Revoked Notice', description: 'FP IID Deferment Revoked Notice', active: true, sortOrder: 9999 });
        this._dictionary.add('2321', { id: 2321, value: 'IID Deferment Revoked Notice', formNumber: '96-0629', displayValue: 'IID Deferment Revoked Notice', description: 'IID Deferment Revoked Notice', active: true, sortOrder: 9999 });
        this._dictionary.add('2327', { id: 2327, value: 'Driver License Renewal Invitation', formNumber: '15-1057', displayValue: 'Driver License Renewal Invitation', description: 'Driver License Renewal Invitation (Artifact)', active: true, sortOrder: 9999 });
        this._dictionary.add('2328', { id: 2328, value: 'FormPortDriverLicenseRenewalInvitation', formNumber: '15-1057', displayValue: 'FP Driver License Renewal Invitation', description: 'Driver License Renewal Invitation', active: true, sortOrder: 9999 });
        this._dictionary.add('2330', { id: 2330, value: 'FP ECD OffHighwayVehicleDecalAuthorization', formNumber: '96-0571', displayValue: 'FP ECD Off Highway Vehicle Decal Authorization', description: 'FP ECD Off Highway Vehicle Decal Authorization', active: true, sortOrder: 9999 });
        this._dictionary.add('2307', { id: 2307, value: 'ReversalReceipt', formNumber: '', displayValue: 'Miscellaneous Reversal Receipt', description: 'Miscellaneous Reversal Receipt', active: true, sortOrder: 99999 });
        this._dictionary.add('2314', { id: 2314, value: 'FormPortTTEAP', formNumber: '96-0532', displayValue: 'FP TTEAP', description: 'FP Traffic Ticket Enforcement Assistance Program', active: true, sortOrder: 99999 });
        this._dictionary.add('2316', { id: 2316, value: 'TTEAP', formNumber: '96-0532', displayValue: 'TTEAP', description: 'Traffic Ticket Enforcement Assistance Program', active: true, sortOrder: 99999 });
        this._dictionary.add('2325', { id: 2325, value: 'LitterLetter', formNumber: '23', displayValue: 'Litter Letter', description: 'Litter Letter Artifact', active: true, sortOrder: 99999 });
        this._dictionary.add('100', { id: 100, value: 'DisabilityHearingImpairedPlatePlacardApplication', formNumber: '96-0104', displayValue: 'Disability - Hearing Impaired Plate/Placard Application', description: 'Disability - Hearing Impaired Plate/Placard Application', active: true, sortOrder: 999999 });
        this._dictionary.add('101', { id: 101, value: 'PlacardRenewalReplacementRequest', formNumber: '40-0112', displayValue: 'Placard Renewal Replacement Request', description: 'Placard Renewal Replacement Request', active: true, sortOrder: 999999 });
        this._dictionary.add('102', { id: 102, value: 'MilitaryOrders', formNumber: '', displayValue: 'Military Orders', description: 'Military Orders', active: true, sortOrder: 999999 });
        this._dictionary.add('103', { id: 103, value: 'SpecialtyMilitaryExemption', formNumber: '96-0240', displayValue: 'Special Military Exemption', description: 'Special Military Exemption', active: true, sortOrder: 999999 });
        this._dictionary.add('104', { id: 104, value: 'AffidavitExemptNonResidentServicePersonnel', formNumber: '', displayValue: 'Affidavit Exempt Non-Resident Service Personnel', description: 'Affidavit Exempt Non-Resident Service Personnel', active: true, sortOrder: 999999 });
        this._dictionary.add('105', { id: 105, value: 'VALetter100%DisabledRate', formNumber: '', displayValue: 'VA Letter 100% Disabled Rate', description: 'VA Letter indicating 100% disabled rate', active: true, sortOrder: 999999 });
        this._dictionary.add('106', { id: 106, value: 'VALetter', formNumber: '', displayValue: 'VA Letter', description: 'VA Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('107', { id: 107, value: 'LeaseContract', formNumber: '', displayValue: 'Lease Contract', description: 'Lease Contract', active: true, sortOrder: 999999 });
        this._dictionary.add('108', { id: 108, value: 'SchoolDistrictLetter', formNumber: '', displayValue: 'School District Letter', description: 'School District Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('109', { id: 109, value: 'CountyAssessorExemptionLetter', formNumber: '', displayValue: 'County Assessor Exemption Letter', description: 'County Assessor Exemption Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('110', { id: 110, value: 'OrganizationHeadquartersLetter', formNumber: '', displayValue: 'Organization Headquarters Letter', description: 'Organization Headquarters Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('111', { id: 111, value: 'IRS501(c)(3)ExemptionRuling', formNumber: '', displayValue: 'IRS 501(c)(3) Exemption Ruling', description: 'IRS 501(c)(3) Exemption Ruling', active: true, sortOrder: 999999 });
        this._dictionary.add('112', { id: 112, value: 'BenefitAwardLetterSSA/BenefitVerification', formNumber: '', displayValue: 'Benefit Award Letter SSA/Benefit Verification', description: 'Benefit Award Letter Social Security Administration or Benefit Verification', active: true, sortOrder: 999999 });
        this._dictionary.add('113', { id: 113, value: 'VLTTribalExemption', formNumber: '48-7701', displayValue: 'VLT Tribal Exemption', description: 'Vehicle License Tax Exemption', active: true, sortOrder: 999999 });
        this._dictionary.add('114', { id: 114, value: 'Waiver/LetterFromTribalCouncil', formNumber: '', displayValue: 'Waiver/Letter From Tribal Council', description: 'Waiver/Letter From Tribal Council', active: true, sortOrder: 999999 });
        this._dictionary.add('115', { id: 115, value: 'Assessor\'sOfficeDocument', formNumber: '', displayValue: 'Assessor\'s Office Document', description: 'Assessor\'s Office Document', active: true, sortOrder: 999999 });
        this._dictionary.add('116', { id: 116, value: 'TnRApplicationServiceOption18', formNumber: '', displayValue: 'Title and Registration Application Service Option 18', description: 'Title and Registration Application Service Option 18', active: true, sortOrder: 999999 });
        this._dictionary.add('117', { id: 117, value: 'SurvivorFallenResponderExemption', formNumber: '48-7702', displayValue: 'Survivor Fallen Responder Exemption', description: 'Survivor of Fallen Responder Exemption ', active: true, sortOrder: 999999 });
        this._dictionary.add('119', { id: 119, value: 'SurvivorFallenMilitaryMemberExemption', formNumber: '48-7703', displayValue: 'Survivor Fallen Military Member Exemption', description: 'Survivor of Fallen Military Member Exemption ', active: true, sortOrder: 999999 });
        this._dictionary.add('120', { id: 120, value: 'DDForm1300ReportofCasualty', formNumber: 'DD 1300', displayValue: 'DD Form 1300 Report of Casualty', description: 'DD Form 1300 Report of Casualty', active: true, sortOrder: 999999 });
        this._dictionary.add('121', { id: 121, value: '100%DisabledExemptionRenewalAffirmation', formNumber: '', displayValue: '100% Disabled Exemption Renewal Affirmation', description: '100% Disabled Exemption Renewal Affirmation', active: true, sortOrder: 999999 });
        this._dictionary.add('122', { id: 122, value: 'VehicleTitle', formNumber: '', displayValue: 'FP Vehicle Title', description: 'FormPort Vehicle Title', active: true, sortOrder: 999999 });
        this._dictionary.add('123', { id: 123, value: 'DD214', formNumber: '', displayValue: 'DD 214', description: 'DD214  (Certificate of Release or Discharge from Active Duty)', active: true, sortOrder: 999999 });
        this._dictionary.add('124', { id: 124, value: 'DD215', formNumber: '', displayValue: 'DD 215', description: 'DD215  (Certificate of Release or Discharge from Active Duty)', active: true, sortOrder: 999999 });
        this._dictionary.add('125', { id: 125, value: 'WDAGO52-98', formNumber: '', displayValue: 'WD AGO 52-98', description: 'WD AGO 52-98 (Notice of Separation from the United States Army)', active: true, sortOrder: 999999 });
        this._dictionary.add('126', { id: 126, value: 'WDAGO53-55', formNumber: '', displayValue: 'WD AGO 53-55', description: 'WD AGO 53-55 (Notice of Separation from the United States Army)', active: true, sortOrder: 999999 });
        this._dictionary.add('127', { id: 127, value: 'NAVPERS553', formNumber: '', displayValue: 'NAVPERS 553', description: 'NAVPERS 553 ( Notice of Separation from U.S. Naval Service)', active: true, sortOrder: 999999 });
        this._dictionary.add('128', { id: 128, value: 'NAVMC78', formNumber: '', displayValue: 'NAVMC 78', description: 'NAVMC 78 (United States Marine Corps Report of Separation)', active: true, sortOrder: 999999 });
        this._dictionary.add('129', { id: 129, value: 'FCCLicense', formNumber: '', displayValue: 'FCC License', description: 'Amateur Radio License issued by the FCC', active: true, sortOrder: 999999 });
        this._dictionary.add('130', { id: 130, value: 'ReducedMotorCarrierFeeCertificate', formNumber: '96-0141', displayValue: 'Reduced Motor Carrier Fee Certificate', description: 'Reduced Motor Carrier Fee Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('131', { id: 131, value: 'FCC-issuedAmateurRadioLicense', formNumber: '', displayValue: 'FCC-issued Amateur Radio License', description: 'FCC-issued Amateur Radio License', active: true, sortOrder: 999999 });
        this._dictionary.add('132', { id: 132, value: 'FormerPOWCertificate', formNumber: '', displayValue: 'Former Prisoner Of War Certificate', description: 'Former Prisoner Of War Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('133', { id: 133, value: 'IAFFApplication', formNumber: '', displayValue: 'International Association of Firefighters Application', description: 'International Association of Firefighters Application', active: true, sortOrder: 999999 });
        this._dictionary.add('134', { id: 134, value: 'FOPApplication', formNumber: '', displayValue: 'Fraternal Order of Police Application', description: 'Fraternal Order of Police Application', active: true, sortOrder: 999999 });
        this._dictionary.add('135', { id: 135, value: 'VeteransServiceformAVSC02-025partII', formNumber: 'AVSC02-025', displayValue: 'Veterans Service form AVSC02-025 part II', description: 'Veterans Service form AVSC02-025 part II', active: true, sortOrder: 999999 });
        this._dictionary.add('136', { id: 136, value: 'ConsularIdentificationCard', formNumber: '', displayValue: 'Consular Identification Card', description: 'Consular Identification Card', active: true, sortOrder: 999999 });
        this._dictionary.add('137', { id: 137, value: 'StatementofHonorableDischarge', formNumber: '', displayValue: 'Statement of Honorable Discharge', description: 'Statement of Honorable Discharge', active: true, sortOrder: 999999 });
        this._dictionary.add('138', { id: 138, value: 'AmericanLegionCard', formNumber: '', displayValue: 'American Legion Card', description: 'American Legion Card', active: true, sortOrder: 999999 });
        this._dictionary.add('139', { id: 139, value: 'DisabledAmericanVeteranCard', formNumber: '', displayValue: 'Disabled American Veteran Card', description: 'Disabled American Veteran Card', active: true, sortOrder: 999999 });
        this._dictionary.add('140', { id: 140, value: 'MilitaryOfficersOfAmericaCard', formNumber: '', displayValue: 'Military Officers Of America Card', description: 'Military Officers Of America Card', active: true, sortOrder: 999999 });
        this._dictionary.add('141', { id: 141, value: 'VeteransAdministrationMedicalCard', formNumber: '', displayValue: 'Veterans Administration Medical Card', description: 'Veterans Administration Medical Card', active: true, sortOrder: 999999 });
        this._dictionary.add('142', { id: 142, value: 'VeteransOfForeignWarsCard', formNumber: '', displayValue: 'Veterans Of Foreign Wars Card', description: 'Veterans Of Foreign Wars Card', active: true, sortOrder: 999999 });
        this._dictionary.add('143', { id: 143, value: 'MilitaryOrderOfThePurpleHeart', formNumber: '', displayValue: 'Military Order Of The Purple Heart', description: 'Military Order Of The Purple Heart', active: true, sortOrder: 999999 });
        this._dictionary.add('144', { id: 144, value: 'VietnamVeteransOfAmericaCard', formNumber: '', displayValue: 'Vietnam Veterans Of America Card', description: 'Vietnam Veterans Of America Card', active: true, sortOrder: 999999 });
        this._dictionary.add('145', { id: 145, value: 'ActiveDutyMilitaryCard', formNumber: '', displayValue: 'Active Duty Military Card', description: 'Active Duty Military Card', active: true, sortOrder: 999999 });
        this._dictionary.add('146', { id: 146, value: 'InactiveDutyMilitaryCard', formNumber: '', displayValue: 'Inactive Duty Military Card', description: 'Inactive Duty Military Card', active: true, sortOrder: 999999 });
        this._dictionary.add('147', { id: 147, value: 'ArizonaDriverLicensewithVeteranmark', formNumber: '', displayValue: 'Arizona Driver License with Veteran mark', description: 'Arizona Driver License with Veteran mark', active: true, sortOrder: 999999 });
        this._dictionary.add('148', { id: 148, value: 'ArizonaCommercialDriverLicensewithVeteranmark', formNumber: '', displayValue: 'Arizona Commercial Driver License with Veteran mark', description: 'Arizona Commercial Driver License with Veteran mark', active: true, sortOrder: 999999 });
        this._dictionary.add('149', { id: 149, value: 'ArizonaInstructionalPermitwithVeteranmark', formNumber: '', displayValue: 'Arizona Instructional Permit with Veteran mark', description: 'Arizona Instructional Permit with Veteran mark', active: true, sortOrder: 999999 });
        this._dictionary.add('150', { id: 150, value: 'ArizonaIdentificationCardwithVeteranmark', formNumber: '', displayValue: 'Arizona Identification Card with Veteran mark', description: 'Arizona Identification Card with Veteran mark', active: true, sortOrder: 999999 });
        this._dictionary.add('151', { id: 151, value: 'AffidavitfromCommandingOfficer', formNumber: '', displayValue: 'Affidavit from Commanding Officer', description: 'Affidavit from Commanding Officer', active: true, sortOrder: 999999 });
        this._dictionary.add('153', { id: 153, value: 'DelayedUSBirthCertificate', formNumber: '', displayValue: 'Delayed US Birth Certificate', description: 'U.S. Certificate of Birth Abroad (FS-240, 545 or DS-1350)', active: true, sortOrder: 999999 });
        this._dictionary.add('154', { id: 154, value: 'ArizonaCertificateofForeignBirth', formNumber: '', displayValue: 'Arizona Certificate of Foreign Birth ', description: 'Arizona Certificate of Foreign Birth ', active: true, sortOrder: 999999 });
        this._dictionary.add('155', { id: 155, value: 'TribalorBureauofIndianAffairsAffidavitofBirth', formNumber: '', displayValue: 'Tribal or Bureau of Indian Affairs Affidavit of Birth', description: 'Tribal or Bureau of Indian Affairs Affidavit of Birth', active: true, sortOrder: 999999 });
        this._dictionary.add('158', { id: 158, value: 'U.S.CertificateofNaturalization', formNumber: '', displayValue: 'U.S. Certificate of Naturalization', description: 'U.S. Certificate of Naturalization issued by DHS Form N-550, or From N-570', active: true, sortOrder: 999999 });
        this._dictionary.add('159', { id: 159, value: 'U.S.CertificateofCitizenship', formNumber: '', displayValue: 'U.S. Certificate of Citizenship', description: 'U.S. Certificate of Citizenship, N-560 or N561 issued by DHS', active: true, sortOrder: 999999 });
        this._dictionary.add('163', { id: 163, value: 'TemporaryI-551Stamp(onpassportorI-94)', formNumber: '', displayValue: 'Temporary I-551 Stamp (on passport or I- 94)', description: 'Temporary I-551 Stamp (on passport or I- 94)', active: true, sortOrder: 999999 });
        this._dictionary.add('165', { id: 165, value: 'I-94withoutphoto', formNumber: 'I-94', displayValue: 'I-94 without photo', description: 'I-94 Form without Photo, presented without passport.', active: true, sortOrder: 999999 });
        this._dictionary.add('166', { id: 166, value: 'I-571', formNumber: 'I-571', displayValue: 'I-571 Refugee Travel Document', description: 'Refugee Travel Document, I-571', active: true, sortOrder: 999999 });
        this._dictionary.add('168', { id: 168, value: 'U.S.MilitaryIDCard(reserveorretired)', formNumber: '', displayValue: 'U.S. Military ID Card (reserve or retired)', description: 'U.S. Military ID Card (reserve or retired)', active: true, sortOrder: 999999 });
        this._dictionary.add('169', { id: 169, value: 'U.S.MilitaryDependentIDCard', formNumber: '', displayValue: 'U.S. Military Dependent ID Card', description: 'U.S. Military Dependent ID Card', active: true, sortOrder: 999999 });
        this._dictionary.add('170', { id: 170, value: 'U.S.ArmedForcesDriverLicense', formNumber: '', displayValue: 'U.S. Armed Forces Driver License', description: 'U.S. Armed Forces Driver License', active: true, sortOrder: 999999 });
        this._dictionary.add('171', { id: 171, value: 'U.S.DepartmentofVeteran’sAffairsCard', formNumber: '', displayValue: 'U.S. Department of Veteran’s Affairs Card', description: 'U.S. Department of Veteran’s Affairs Card', active: true, sortOrder: 999999 });
        this._dictionary.add('172', { id: 172, value: 'SelectiveServiceCard', formNumber: '', displayValue: 'Selective Service Card', description: 'Selective Service Card', active: true, sortOrder: 999999 });
        this._dictionary.add('173', { id: 173, value: 'OOSEnhancedDL', formNumber: '', displayValue: 'OOS Enhanced DL', description: 'Enhanced Driver License issued by any U.S. State (evidenced by the word “Enhanced” printed on the card)', active: true, sortOrder: 999999 });
        this._dictionary.add('174', { id: 174, value: 'OOSEnhancedCDL', formNumber: '', displayValue: 'OOS Enhanced CDL', description: 'Enhanced Commercial Driver License issued by any U.S. State (evidenced by the word “Enhanced” printed on the card)', active: true, sortOrder: 999999 });
        this._dictionary.add('175', { id: 175, value: 'OOSEnhancedID', formNumber: '', displayValue: 'OOS Enhanced ID', description: 'Enhanced ID Card issued by any U.S. State (evidenced by the word “Enhanced” printed on the card)', active: true, sortOrder: 999999 });
        this._dictionary.add('176', { id: 176, value: 'OOSIP', formNumber: '', displayValue: 'OOS IP', description: 'Instruction Permit issued by any state, territory or possession of the U.S.', active: true, sortOrder: 999999 });
        this._dictionary.add('177', { id: 177, value: 'OOSCLP', formNumber: '', displayValue: 'OOS CLP', description: 'Commercial Learner Permit issued by any state, territory or possession of the U.S.', active: true, sortOrder: 999999 });
        this._dictionary.add('178', { id: 178, value: 'OOSIDCard', formNumber: '', displayValue: 'OOS ID Card', description: 'Identification Card issued by any state, territory or possession of the U.S.', active: true, sortOrder: 999999 });
        this._dictionary.add('180', { id: 180, value: 'REALIDCDL', formNumber: '', displayValue: 'REAL ID CDL', description: 'REAL ID commercial driver\'s license ', active: true, sortOrder: 999999 });
        this._dictionary.add('181', { id: 181, value: 'REALIDIDCard', formNumber: '', displayValue: 'REAL ID ID Card', description: 'REAL ID Identification Card', active: true, sortOrder: 999999 });
        this._dictionary.add('182', { id: 182, value: 'MVR', formNumber: '', displayValue: 'MVR', description: 'Motor Vehicle Record or Clearance Letter within 30 days of issue', active: true, sortOrder: 999999 });
        this._dictionary.add('183', { id: 183, value: 'EnhancedTribalCard', formNumber: '', displayValue: 'Enhanced Tribal Card', description: 'Enhanced Tribal Card (Tohono O’odham Nation, Kootenai Tribe and Pascua Yesaqui Tribe)', active: true, sortOrder: 999999 });
        this._dictionary.add('184', { id: 184, value: 'TribalCertificateofIndianBlood', formNumber: '', displayValue: 'Tribal Certificate of Indian Blood', description: 'Tribal Certificate of Indian Blood', active: true, sortOrder: 999999 });
        this._dictionary.add('185', { id: 185, value: 'W-2Form', formNumber: 'W-2', displayValue: 'W-2 Form', description: 'W-2 Form', active: true, sortOrder: 999999 });
        this._dictionary.add('186', { id: 186, value: 'InmateIDCard', formNumber: '', displayValue: 'Inmate ID Card', description: 'U.S. Department of Justice Inmate ID Card ', active: true, sortOrder: 999999 });
        this._dictionary.add('187', { id: 187, value: 'AffidavitofIdentification(DOC)', formNumber: '', displayValue: 'Affidavit of Identification(DOC)', description: 'Affidavit of Identification issued by Arizona Department of Corrections ', active: true, sortOrder: 999999 });
        this._dictionary.add('188', { id: 188, value: 'ReleasedOffenderID', formNumber: '', displayValue: 'Released Offender ID', description: 'Released Offender ID with Photo from Arizona Department of Corrections', active: true, sortOrder: 999999 });
        this._dictionary.add('189', { id: 189, value: 'AffidavitofIdentification(MaricopaCo.AdultProbation)', formNumber: '', displayValue: 'Affidavit of Identification (Maricopa Co. Adult Probation)', description: 'Affidavit of Identification with photo issued by Maricopa County Adult Probation Department within15 days of issue.', active: true, sortOrder: 999999 });
        this._dictionary.add('190', { id: 190, value: 'CommunityRe-EntryID', formNumber: '', displayValue: 'Community Re-Entry ID', description: 'ALPHA Program/Community Re-Entry ID from the Maricopa Co. Sheriff’s Office', active: true, sortOrder: 999999 });
        this._dictionary.add('191', { id: 191, value: 'SocialSecurityCard', formNumber: '', displayValue: 'Social Security Card', description: 'Social Security Card', active: true, sortOrder: 999999 });
        this._dictionary.add('192', { id: 192, value: '1099Form', formNumber: '1099', displayValue: '1099 Form', description: '1099 Form', active: true, sortOrder: 999999 });
        this._dictionary.add('193', { id: 193, value: 'PaystubshowingSSN', formNumber: '', displayValue: 'Paystub showing SSN', description: 'Paystub showing SSN', active: true, sortOrder: 999999 });
        this._dictionary.add('194', { id: 194, value: 'ConcealedWeaponsPermit/License', formNumber: '', displayValue: 'Concealed Weapons Permit/License', description: 'Concealed Weapons Permit/License', active: true, sortOrder: 999999 });
        this._dictionary.add('196', { id: 196, value: 'CertifiedLetterofIdentificationforaWardoftheCourt', formNumber: '', displayValue: 'Certified Letter of Identification for a Ward of the Court', description: 'Certified Letter of Identification for a Ward of the Court', active: true, sortOrder: 999999 });
        this._dictionary.add('197', { id: 197, value: 'AdoptionDecree', formNumber: '', displayValue: 'Adoption Decree', description: 'Adoption Decree', active: true, sortOrder: 999999 });
        this._dictionary.add('198', { id: 198, value: 'BankruptcyDecree', formNumber: '', displayValue: 'Bankruptcy Decree', description: 'Bankruptcy Decree', active: true, sortOrder: 999999 });
        this._dictionary.add('200', { id: 200, value: 'EmancipationDecree', formNumber: '', displayValue: 'Emancipation Decree', description: 'Emancipation Decree', active: true, sortOrder: 999999 });
        this._dictionary.add('201', { id: 201, value: 'LegalGuardianDecree', formNumber: '', displayValue: 'Legal Guardian Decree', description: 'Legal Guradian Degree', active: true, sortOrder: 999999 });
        this._dictionary.add('203', { id: 203, value: 'ProfessionalLicense', formNumber: '', displayValue: 'Professional License', description: 'Professional License', active: true, sortOrder: 999999 });
        this._dictionary.add('204', { id: 204, value: 'EmployeeIDBadgewithPhoto', formNumber: '', displayValue: 'Employee ID Badge with Photo', description: 'Employee ID Badge with Photo', active: true, sortOrder: 999999 });
        this._dictionary.add('205', { id: 205, value: 'SchoolIDwithPhoto', formNumber: '', displayValue: 'School ID with Photo', description: 'School ID with Photo', active: true, sortOrder: 999999 });
        this._dictionary.add('206', { id: 206, value: 'MedicalInsuranceCard', formNumber: '', displayValue: 'Medical Insurance Card ', description: 'Medical Insurance Card (including AHCCCS ID Card)', active: true, sortOrder: 999999 });
        this._dictionary.add('207', { id: 207, value: 'LegalGuardianCertificate', formNumber: '', displayValue: 'Legal Guardian Certificate', description: 'Legal Guardian Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('208', { id: 208, value: 'MortgageDocument', formNumber: '', displayValue: 'Mortgage Document', description: 'Mortgage Document', active: true, sortOrder: 999999 });
        this._dictionary.add('210', { id: 210, value: 'VoterRegistrationCard', formNumber: '', displayValue: 'Voter Registration Card', description: 'Voter Registration Card - Valid/ Unexpired', active: true, sortOrder: 999999 });
        this._dictionary.add('212', { id: 212, value: 'HealthInsuranceCardw/address', formNumber: '', displayValue: 'Health Insurance Card w/ address', description: 'Medical Insurance or Health Insurance  Card with Address Listed', active: true, sortOrder: 999999 });
        this._dictionary.add('214', { id: 214, value: 'ReportCardorTranscript', formNumber: '', displayValue: 'Report Card or Transcript', description: 'High School, College or university Report Card or Transcript for the Current year', active: true, sortOrder: 999999 });
        this._dictionary.add('217', { id: 217, value: 'AutoPaymentBook/Statement', formNumber: '', displayValue: 'Auto Payment Book/Statement', description: 'Current Automobile Payment Booklet or Statement ', active: true, sortOrder: 999999 });
        this._dictionary.add('218', { id: 218, value: 'VehicleLoanDocument', formNumber: '', displayValue: 'Vehicle Loan Document', description: 'Vehicle Loan Document', active: true, sortOrder: 999999 });
        this._dictionary.add('219', { id: 219, value: 'Paycheck/PaystubwithoutSSN', formNumber: '', displayValue: 'Paycheck/Paystub without SSN', description: 'Preprinted Paycheck, or payment Stub Date within 30 days of the Date of Application ', active: true, sortOrder: 999999 });
        this._dictionary.add('220', { id: 220, value: 'MilitaryDocuments', formNumber: '', displayValue: 'Military Documents', description: 'Current Documents issued by the  Military indicating Residence Address', active: true, sortOrder: 999999 });
        this._dictionary.add('221', { id: 221, value: 'Release/ParoleDocument(AZ)', formNumber: '', displayValue: 'Release/Parole Document (AZ)', description: 'Document from an AZ based Corrections Facility indicating Applicant\'s recent Release or Parole', active: true, sortOrder: 999999 });
        this._dictionary.add('222', { id: 222, value: 'Auto/LifeInsurance', formNumber: '', displayValue: 'Auto/Life Insurance', description: 'Auto or Life Insurance Policy Binder', active: true, sortOrder: 999999 });
        this._dictionary.add('223', { id: 223, value: 'USPSChangeofAddressconfirmation/PostmarkedMail', formNumber: '', displayValue: 'USPS Change of Address confirmation/Postmarked Mail', description: 'U.S. postal Service Change of Address Confirmation Form or Postmarked Mail with Forwarding Address', active: true, sortOrder: 999999 });
        this._dictionary.add('224', { id: 224, value: 'ForwardedMail', formNumber: '', displayValue: 'Forwarded Mail', description: 'Mail Forwarded tonew  Address by the U.S. Post Office displaying Yellow Re-Routing Sticker ', active: true, sortOrder: 999999 });
        this._dictionary.add('225', { id: 225, value: 'CourtDocumentwithAddress', formNumber: '', displayValue: 'Court Document with Address', description: 'Court Document with Address', active: true, sortOrder: 999999 });
        this._dictionary.add('226', { id: 226, value: 'StatementofAddress', formNumber: '', displayValue: 'Statement of Address from Homeless Shelter', description: 'Statement on a Homeless Shelter Letterhead, Transitional Service Provider, Halfway House or Religious Institution Certifiying the Applicants Address', active: true, sortOrder: 999999 });
        this._dictionary.add('227', { id: 227, value: 'AZAddressConfidentialityProgramResidencyLetter', formNumber: '', displayValue: 'AZ Address Confidentiality Program Residency Letter', description: 'AZ Address Confidentiality Program Residency Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('228', { id: 228, value: 'AZAddressConfidentialityProgramAuthorizationCard', formNumber: '', displayValue: 'AZ Address Confidentiality Program Authorization Card', description: 'AZ Address Confidentiality Program Authorization Card', active: true, sortOrder: 999999 });
        this._dictionary.add('229', { id: 229, value: 'AZResidencyAffidavit', formNumber: '40-5143', displayValue: 'AZ Residency Affidavit', description: 'AZ Residency Affidavit - Individual providing the statement must provide proof of residence at the time of application', active: true, sortOrder: 999999 });
        this._dictionary.add('232', { id: 232, value: 'OOSCDL', formNumber: '', displayValue: 'OOS CDL', description: 'Commercial Driver License issued by any state, territory or possession of the U.S.', active: true, sortOrder: 999999 });
        this._dictionary.add('233', { id: 233, value: 'OOSMotorcycleDL', formNumber: '', displayValue: 'OOS Motorcycle DL', description: 'Motorcycle Driver License issued by any state, territory or possession of the U.S.', active: true, sortOrder: 999999 });
        this._dictionary.add('234', { id: 234, value: 'OOSEnhancedMotorcycleDL', formNumber: '', displayValue: 'OOS Enhanced Motorcycle DL', description: 'Enhanced Motorcycle Driver License issued by any U.S. State (evidenced by the word “Enhanced” printed on the card)', active: true, sortOrder: 999999 });
        this._dictionary.add('235', { id: 235, value: 'REALIDMotorcycleDL', formNumber: '', displayValue: 'REAL ID Motorcycle DL', description: 'REAL ID driver\'s license ', active: true, sortOrder: 999999 });
        this._dictionary.add('236', { id: 236, value: 'HighSchoolDriverEducationEnrollment', formNumber: '', displayValue: 'High School Driver Education Enrollment ', description: 'Driver Education Document showing enrollment in an MVD approved course', active: true, sortOrder: 999999 });
        this._dictionary.add('237', { id: 237, value: 'HighSchoolDriverEducationCertificate', formNumber: '96-0254', displayValue: 'High School Driver Education Certificate', description: 'High School Driver Education Certificate #96-0254', active: true, sortOrder: 999999 });
        this._dictionary.add('238', { id: 238, value: 'ATPDLTrainingCompletionCertificate(TCC)', formNumber: '', displayValue: 'ATP DL Training Completion Certificate (TCC)', description: 'ATP DL Training Completion Certificate (TCC)', active: true, sortOrder: 999999 });
        this._dictionary.add('239', { id: 239, value: 'MSFRiderCourseCompletionCertificate', formNumber: '', displayValue: 'MSF  Rider Course Completion Certificate', description: 'MSF  Rider Course Completion Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('240', { id: 240, value: 'TotalControlCompletionCard', formNumber: '', displayValue: 'Total Control Completion Card', description: 'Total Control Completion Card', active: true, sortOrder: 999999 });
        this._dictionary.add('241', { id: 241, value: 'SpecialPerformanceEvaluationCertificateofCompletion', formNumber: '96-0487', displayValue: 'Special Performance Evaluation Certificate of Completion', description: 'Special Performance Evaluation Certificate of Completion #96-0487', active: true, sortOrder: 999999 });
        this._dictionary.add('242', { id: 242, value: 'MilitarySkillsTestWaiver', formNumber: '96-0680', displayValue: 'Military Skills Test Waiver', description: 'Military Skills Test Waiver #96-0680', active: true, sortOrder: 999999 });
        this._dictionary.add('243', { id: 243, value: 'VisionExamReport', formNumber: '', displayValue: 'Vision Exam Report', description: 'Vision Exam Report complerted', active: true, sortOrder: 999999 });
        this._dictionary.add('244', { id: 244, value: 'MedicalProfessionalStatement', formNumber: '', displayValue: 'Medical Professional Statement', description: 'Medical Professional Statement', active: true, sortOrder: 999999 });
        this._dictionary.add('245', { id: 245, value: 'DD-2(Retired)', formNumber: 'DD-2', displayValue: 'DD-2 (Retired)', description: 'United States Uniformed Services Identification Card', active: true, sortOrder: 999999 });
        this._dictionary.add('246', { id: 246, value: 'DD-2(Reserve)', formNumber: 'DD-2', displayValue: 'DD-2 (Reserve)', description: 'Armed Forces of the United States Geneva Conventions Identification Card', active: true, sortOrder: 999999 });
        this._dictionary.add('247', { id: 247, value: 'DD-217', formNumber: 'DD-217', displayValue: 'DD-217', description: 'Discharge Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('248', { id: 248, value: 'OriginalStatementofHonorableService', formNumber: '', displayValue: 'Original Statement of Honorable Service ', description: 'Original Statement of Honorable Service ', active: true, sortOrder: 999999 });
        this._dictionary.add('249', { id: 249, value: 'CertificateofHonorableDischarge', formNumber: '', displayValue: 'Certificate of Honorable Discharge', description: 'Certificate of Honorable Discharge', active: true, sortOrder: 999999 });
        this._dictionary.add('250', { id: 250, value: 'AffidavitofSale', formNumber: '', displayValue: 'Affidavit of Sale', description: 'Affidavit of Sale', active: true, sortOrder: 999999 });
        this._dictionary.add('251', { id: 251, value: 'AuthorizationtoTransferOwnership', formNumber: '46-8922', displayValue: 'Authorization to Transfer Ownership', description: 'Authorization to Transfer Ownership', active: true, sortOrder: 999999 });
        this._dictionary.add('252', { id: 252, value: 'BeneficiaryDesignation', formNumber: '96-0561', displayValue: 'Beneficiary Designation', description: 'Beneficiary Designation', active: true, sortOrder: 999999 });
        this._dictionary.add('253', { id: 253, value: 'BillofSale', formNumber: '', displayValue: 'Bill of Sale', description: 'Bill of Sale', active: true, sortOrder: 999999 });
        this._dictionary.add('254', { id: 254, value: 'Court-issuedJudgement', formNumber: '', displayValue: 'Court-issued Judgement', description: 'Court-issued Judgement', active: true, sortOrder: 999999 });
        this._dictionary.add('255', { id: 255, value: 'Court-issuedOrderofForfeiture', formNumber: '', displayValue: 'Court-issued Order of Forfeiture ', description: 'Court-issued Order of Forfeiture ', active: true, sortOrder: 999999 });
        this._dictionary.add('256', { id: 256, value: 'Court-issuedDivorceDecree', formNumber: '', displayValue: 'Court-issued Divorce Decree', description: 'Court-issued Divorce Decree', active: true, sortOrder: 999999 });
        this._dictionary.add('257', { id: 257, value: 'NoticeofTerminationofLease', formNumber: '', displayValue: 'Notice of Termination of Lease', description: 'Notice of Termination of Lease', active: true, sortOrder: 999999 });
        this._dictionary.add('258', { id: 258, value: 'WorkOrdersignedbyownerofrecord', formNumber: '', displayValue: 'Work Order signed by owner of record', description: 'Work Order signed by owner of record', active: true, sortOrder: 999999 });
        this._dictionary.add('259', { id: 259, value: 'Declaration(forArizonatitledvehiclesonly)', formNumber: '', displayValue: 'Declaration (for Arizona titled vehicles only)', description: 'Declaration (for Arizona titled vehicles only)', active: true, sortOrder: 999999 });
        this._dictionary.add('260', { id: 260, value: 'LessorAuthorization', formNumber: '40-0207', displayValue: 'Lessor Authorization', description: 'Lessor Authorization ', active: true, sortOrder: 999999 });
        this._dictionary.add('261', { id: 261, value: 'LienClearance', formNumber: '48-9901', displayValue: 'Lien Clearance', description: 'Lien Clearance', active: true, sortOrder: 999999 });
        this._dictionary.add('262', { id: 262, value: 'MCO(ManufacturersCertificateofOrigin)', formNumber: '', displayValue: 'MCO (Manufacturers Certificate of Origin)', description: 'MCO (Manufacturers Certificate of Origin)', active: true, sortOrder: 999999 });
        this._dictionary.add('263', { id: 263, value: 'MechanicsLein', formNumber: '48-7810', displayValue: 'Mechanics Lien', description: 'Mechanics Lien', active: true, sortOrder: 999999 });
        this._dictionary.add('264', { id: 264, value: 'MotorVehicleRecord', formNumber: '46-4416', displayValue: 'Motor Vehicle Record', description: 'Motor Vehicle Record', active: true, sortOrder: 999999 });
        this._dictionary.add('265', { id: 265, value: 'Non-ProbateAffidavit', formNumber: '32-6901', displayValue: 'Non-Probate Affidavit', description: 'Non-Probate Affidavit', active: true, sortOrder: 999999 });
        this._dictionary.add('266', { id: 266, value: 'One&the same', formNumber: '38-4306', displayValue: 'One & The Same', description: 'One & The Same', active: true, sortOrder: 999999 });
        this._dictionary.add('267', { id: 267, value: 'OutofStateMVRLienandTitleSearch', formNumber: '', displayValue: 'Out of State MVR Lien and Title Search document', description: 'Out of State MVR Lien and Title Search document', active: true, sortOrder: 999999 });
        this._dictionary.add('268', { id: 268, value: 'PowerofAttorney', formNumber: '48-1001', displayValue: 'Power of Attorney', description: 'Power of Attorney', active: true, sortOrder: 999999 });
        this._dictionary.add('269', { id: 269, value: 'ProbateCourtOrder', formNumber: '', displayValue: 'Probate Court Order ', description: 'Probate Court Order ', active: true, sortOrder: 999999 });
        this._dictionary.add('270', { id: 270, value: 'ProofofNotificationtoOwner', formNumber: '', displayValue: 'Proof of Notification to Owner', description: 'Proof of Notification to Owner', active: true, sortOrder: 999999 });
        this._dictionary.add('271', { id: 271, value: 'ReleaseofInterest', formNumber: '46-0306', displayValue: 'Release of Interest', description: 'Release of Interest', active: true, sortOrder: 999999 });
        this._dictionary.add('272', { id: 272, value: 'RentalAgreement', formNumber: '', displayValue: 'Rental Agreement', description: 'Rental Agreement', active: true, sortOrder: 999999 });
        this._dictionary.add('273', { id: 273, value: 'RepossessionAffidavit', formNumber: '48-0902', displayValue: 'Repossession Affidavit', description: 'Repossession Affidavit', active: true, sortOrder: 999999 });
        this._dictionary.add('274', { id: 274, value: 'SheriffSaleDocument', formNumber: '', displayValue: 'Sheriff Sale Document', description: 'Sheriff Sale Document', active: true, sortOrder: 999999 });
        this._dictionary.add('275', { id: 275, value: 'StatementofError', formNumber: '46-0307', displayValue: 'Statement of Error', description: 'Statement of Error', active: true, sortOrder: 999999 });
        this._dictionary.add('276', { id: 276, value: 'TitleandRegistrationApplication(48-0509)', formNumber: '48-0509', displayValue: 'Title and Registration Application (48-0509)', description: 'Title and Registration Application (48-0509)', active: true, sortOrder: 999999 });
        this._dictionary.add('277', { id: 277, value: 'TitleandRegistrationApplication', formNumber: '96-0236', displayValue: 'Title and Registration Application', description: 'Title and Registration Application', active: true, sortOrder: 999999 });
        this._dictionary.add('278', { id: 278, value: 'AbandonedVehicleReport', formNumber: '46-4402', displayValue: 'Abandoned Vehicle Report', description: 'Abandoned Vehicle Report', active: true, sortOrder: 999999 });
        this._dictionary.add('279', { id: 279, value: 'AbandonedVehicleInspection', formNumber: '40-0209', displayValue: 'Abandoned Vehicle Inspection ', description: 'Abandoned Vehicle Inspection', active: true, sortOrder: 999999 });
        this._dictionary.add('280', { id: 280, value: 'VehicleRemovalWrittenAuthorization', formNumber: '40-0206', displayValue: 'Vehicle Removal Written Authorization', description: 'Vehicle Removal Written Authorization', active: true, sortOrder: 999999 });
        this._dictionary.add('281', { id: 281, value: 'GoverningAuthorityTowPermission', formNumber: '46-1005', displayValue: 'Governing Authority Tow Permission', description: 'Governing Authority Tow Permission', active: true, sortOrder: 999999 });
        this._dictionary.add('282', { id: 282, value: 'ReclaimedVehicleNotice', formNumber: '96-0527', displayValue: 'Reclaimed Vehicle Notice', description: 'Reclaimed Vehicle Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('283', { id: 283, value: 'LawEnforcementMotorcycleTrainingCourseCertificate', formNumber: '', displayValue: 'Law Enforcement Motorcycle Training Course Certificate', description: 'Law Enforcement Motorcycle Training Course Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('284', { id: 284, value: 'CDLDemonstrationTestScoresheet ', formNumber: '', displayValue: 'CDL Demonstration Test Scoresheet ', description: 'CDL Demonstration Test Scoresheet ', active: true, sortOrder: 999999 });
        this._dictionary.add('285', { id: 285, value: 'DrivingPracticeCertificateLegalGuradian', formNumber: '', displayValue: 'Driving Practice Certificate - Legal Guardian', description: 'Driving Practice Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('286', { id: 286, value: 'OOSSchoolBusEndorsement', formNumber: '', displayValue: 'OOS School Bus Endorsement', description: 'OOS School Bus Endorsement', active: true, sortOrder: 999999 });
        this._dictionary.add('287', { id: 287, value: 'OOSPassengerEndorsement', formNumber: '', displayValue: 'OOS Passenger Endorsement', description: 'OOS Passenger Endorsement', active: true, sortOrder: 999999 });
        this._dictionary.add('288', { id: 288, value: 'OOSTankEndorsement', formNumber: '', displayValue: 'OOS Tank Endorsement', description: 'OOS Tank Endorsement', active: true, sortOrder: 999999 });
        this._dictionary.add('289', { id: 289, value: 'MachineReadableImmigrantVisa(withTemporaryI-551Language)', formNumber: '', displayValue: 'Machine Readable Immigrant Visa (with Temporary I-551 Language)', description: 'Machine Readable Immigrant Visa (with Temporary I-551 Language)', active: true, sortOrder: 999999 });
        this._dictionary.add('290', { id: 290, value: 'SoldNotice', formNumber: '46-8502', displayValue: 'Sold Notice', description: 'Sold Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('291', { id: 291, value: 'De-InsuredCertificate', formNumber: '46-0602', displayValue: 'De-Insured Certificate', description: 'De-Insured Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('292', { id: 292, value: 'PermissibleUse', formNumber: '', displayValue: 'Permissible Use', description: 'Permissible Use', active: true, sortOrder: 999999 });
        this._dictionary.add('293', { id: 293, value: 'DrivingPracticeCertificateDriverEducation', formNumber: '', displayValue: 'Driving Practice Certificate - Driver Education', description: 'Driving Practice Certificate - Driver Education', active: true, sortOrder: 999999 });
        this._dictionary.add('294', { id: 294, value: 'I20NonimmigrantStudentCertificate', formNumber: '', displayValue: 'I-20 Nonimmigrant Student Certificate', description: 'Certificate allowing Nonimmigrants to attend school in the US', active: true, sortOrder: 999999 });
        this._dictionary.add('295', { id: 295, value: 'I327ReEntryPermit', formNumber: '', displayValue: 'I-327 Re-Entry Permit ', description: 'Permit to re-enter the US', active: true, sortOrder: 999999 });
        this._dictionary.add('296', { id: 296, value: 'DS2019ExchangeVisitorCertificate', formNumber: '', displayValue: 'DS2019 Exchange Visitor Certificate', description: 'Certificate for US exchange Visitor', active: true, sortOrder: 999999 });
        this._dictionary.add('297', { id: 297, value: 'OdometerStatement', formNumber: '', displayValue: 'Odometer Statement', description: 'Odometer Statement', active: true, sortOrder: 999999 });
        this._dictionary.add('298', { id: 298, value: 'PhysicalInspection', formNumber: '', displayValue: 'Physical Inspection', description: 'Physical Inspection', active: true, sortOrder: 999999 });
        this._dictionary.add('299', { id: 299, value: 'GovtDocumentF97', formNumber: '', displayValue: 'Government Document F-97', description: 'Government Document F-97', active: true, sortOrder: 999999 });
        this._dictionary.add('300', { id: 300, value: 'RegistrationPenaltyFeeWaiverNonUse', formNumber: '48-9402', displayValue: 'Registration Penalty Fee Waiver Non-Use', description: 'Registration Penalty Fee Waiver Non-Use', active: true, sortOrder: 999999 });
        this._dictionary.add('301', { id: 301, value: 'HighwayUseCertificate', formNumber: '96-0371', displayValue: 'Highway Use Certificate', description: 'Highway Use Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('302', { id: 302, value: 'NeighborhoodElectricVehicleForm', formNumber: '96-0124', displayValue: 'Neighborhood Electric Vehicle Form', description: 'Neighborhood Electric Vehicle Form', active: true, sortOrder: 999999 });
        this._dictionary.add('303', { id: 303, value: 'ForHireCertificate', formNumber: '96-0148', displayValue: 'For Hire Certificate', description: 'For Hire Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('304', { id: 304, value: 'TransferOrderExcessPersonalProperty', formNumber: '122', displayValue: 'Transfer Order Excess Personal Property', description: 'Transfer Order Excess Personal Property', active: true, sortOrder: 999999 });
        this._dictionary.add('305', { id: 305, value: 'OffHighwayVehicleDecalAuthorization', formNumber: '96-0571', displayValue: 'FP Off Highway Vehicle Decal Authorization', description: 'FormPort Off Highway Vehicle Decal Authorization', active: true, sortOrder: 999999 });
        this._dictionary.add('306', { id: 306, value: 'DeathCertificate', formNumber: '', displayValue: 'Death Certificate', description: 'Death Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('307', { id: 307, value: 'VehicleCertificateofTitle', formNumber: '', displayValue: 'Vehicle Certificate of Title', description: 'Vehicle Certificate of Title', active: true, sortOrder: 999999 });
        this._dictionary.add('308', { id: 308, value: 'VehicleRegistration', formNumber: '', displayValue: 'FP Vehicle Registration', description: 'FormPort Vehicle Registration', active: true, sortOrder: 999999 });
        this._dictionary.add('309', { id: 309, value: 'DealerInvoice', formNumber: '', displayValue: 'Dealer Invoice', description: 'Dealer Invoice', active: true, sortOrder: 999999 });
        this._dictionary.add('310', { id: 310, value: 'SecurityAgreement', formNumber: '', displayValue: 'Security Agreement', description: 'Security Agreement', active: true, sortOrder: 999999 });
        this._dictionary.add('311', { id: 311, value: 'FinancialInstitutionLetter', formNumber: '', displayValue: 'Financial Institution Letter', description: 'Financial Institution Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('312', { id: 312, value: 'LienRelease', formNumber: '48-9901', displayValue: 'Lien Release', description: 'Lien Release', active: true, sortOrder: 999999 });
        this._dictionary.add('313', { id: 313, value: 'LeinholderPermissionLetter', formNumber: '', displayValue: 'Lienholder Permission Letter', description: 'Lienholder Permission Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('314', { id: 314, value: 'OutOfStateRepossessionAffidavit', formNumber: '', displayValue: 'Out Of State Repossession Affidavit', description: 'Out Of State Repossession Affidavit', active: true, sortOrder: 999999 });
        this._dictionary.add('315', { id: 315, value: 'DecreeOfDistribution', formNumber: '', displayValue: 'Decree Of Distribution', description: 'Decree Of Distribution', active: true, sortOrder: 999999 });
        this._dictionary.add('316', { id: 316, value: 'AppointmentOfTrustee', formNumber: '', displayValue: 'Appointment Of Trustee', description: 'Appointment Of Trustee', active: true, sortOrder: 999999 });
        this._dictionary.add('317', { id: 317, value: 'AppointmentOfReferee', formNumber: '', displayValue: 'Appointment Of Referee', description: 'Appointment Of Referee', active: true, sortOrder: 999999 });
        this._dictionary.add('318', { id: 318, value: 'IRSForm2435', formNumber: '2435', displayValue: 'IRS Form 2435', description: 'IRS Form 2435', active: true, sortOrder: 999999 });
        this._dictionary.add('319', { id: 319, value: 'BondedTitleRequirements', formNumber: '40-1001', displayValue: 'Bonded Title Requirements', description: 'Bonded Title Requirements', active: true, sortOrder: 999999 });
        this._dictionary.add('320', { id: 320, value: 'BondedTitleAffidavit', formNumber: '', displayValue: 'Bonded Title Affidavit', description: 'Bonded Title Affidavit', active: true, sortOrder: 999999 });
        this._dictionary.add('321', { id: 321, value: 'CredentialIssuanceApplication', formNumber: '40-5122', displayValue: 'Credential Issuance Application', description: 'Application for ID DL or CDL', active: true, sortOrder: 999999 });
        this._dictionary.add('322', { id: 322, value: 'MedicalExamReport', formNumber: '32-4005', displayValue: 'Medical Exam Report', description: 'Report completed by a medical doctor to determine if a person is medically capable of safely operating a motor vehicle', active: true, sortOrder: 999999 });
        this._dictionary.add('323', { id: 323, value: 'SubstanceAbuseEvaluation', formNumber: '15-1043', displayValue: 'Substance Abuse Evaluation', description: 'Evaluation completed by a professional to determine if substance abuse inhibits a person from safely operating a motor vehicle', active: true, sortOrder: 999999 });
        this._dictionary.add('324', { id: 324, value: 'DriverConditionBehaviorReport', formNumber: '96-0469', displayValue: 'Driver Condition/Behavior Report', description: 'Report completed by a family member or concerned citizen regarding a persons ability to safely operate a motor vehicle', active: true, sortOrder: 999999 });
        this._dictionary.add('325', { id: 325, value: 'PhysicianExamReport', formNumber: '96-0668', displayValue: 'Physician Exam Report', description: 'Report submitted by a physician (unsolicited) concerning a persons medical capability to safely operate a motor vehicle', active: true, sortOrder: 999999 });
        this._dictionary.add('326', { id: 326, value: 'LEDriverBehaviorReport', formNumber: '46-3903', displayValue: 'Law Enforcement Driver Behavior Report', description: 'Report completed by Law Enforcement regarding a persons ability to safely operate a motor vehicle', active: true, sortOrder: 999999 });
        this._dictionary.add('327', { id: 327, value: 'AZTitleSummary', formNumber: '', displayValue: 'Arizona Title Summary', description: 'Arizona Title Summary', active: true, sortOrder: 999999 });
        this._dictionary.add('328', { id: 328, value: 'TempLicensePlateTempRegistration', formNumber: '', displayValue: 'Temp License Plate Temp Registration', description: 'Temp License Plate Temp Registration', active: true, sortOrder: 999999 });
        this._dictionary.add('329', { id: 329, value: 'AZVehicleRegistration', formNumber: '', displayValue: 'Vehicle Registration', description: 'Vehicle Registration', active: true, sortOrder: 999999 });
        this._dictionary.add('330', { id: 330, value: 'InterimPlacard', formNumber: '', displayValue: 'Interim Placard', description: 'Interim Placard', active: true, sortOrder: 999999 });
        this._dictionary.add('331', { id: 331, value: 'VehicleMVR', formNumber: '', displayValue: 'Vehicle MVR', description: 'Vehicle MVR', active: true, sortOrder: 999999 });
        this._dictionary.add('332', { id: 332, value: 'MotorVehicleRecordArtifact', formNumber: '', displayValue: 'Motor Vehicle Record Artifact', description: 'Motor Vehicle Record Artifact', active: true, sortOrder: 999999 });
        this._dictionary.add('333', { id: 333, value: 'TaxReturn', formNumber: '', displayValue: 'Current Tax Return', description: 'Current Filed tax return - not tax return booklet.', active: true, sortOrder: 999999 });
        this._dictionary.add('334', { id: 334, value: 'SPECertificateofCompletion', formNumber: '', displayValue: 'SPE Certificate of Completion', description: 'SPE Certificate of Completion', active: true, sortOrder: 999999 });
        this._dictionary.add('335', { id: 335, value: 'MedicalExamCertificate', formNumber: 'MCSA-5876', displayValue: 'CDL Medical Exam Certificate', description: 'CDL Medical Exam Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('336', { id: 336, value: 'GuardianshipCourtDocuments', formNumber: '', displayValue: 'Guardianship Court Documents', description: 'Documents determining that a person requires a guradian due to incapacitation or is releasing such person from guardianship', active: true, sortOrder: 999999 });
        this._dictionary.add('337', { id: 337, value: 'FormPortVehRegRenewalNotice', formNumber: '', displayValue: 'FP Vehicle Registration Renewal Notice', description: 'Vehicle Registration Renewal Notice that is sent to FormPort printer', active: true, sortOrder: 999999 });
        this._dictionary.add('338', { id: 338, value: 'VAHomelessCertificationLetter', formNumber: '', displayValue: 'Homeless Verification on Veteran\'s Administration Letterhead', description: 'Statement from Veteran\'s Administration that applicant is homeless', active: true, sortOrder: 999999 });
        this._dictionary.add('339', { id: 339, value: 'VerifiableServiceProviderHomelessCertificationLetter', formNumber: '', displayValue: 'Homeless Verification from a Verifiable Provider of Services', description: 'Statement from a verifiable provider of servcies that applicant is homeless', active: true, sortOrder: 999999 });
        this._dictionary.add('340', { id: 340, value: 'DS1972D', formNumber: '', displayValue: 'DS-1972D (Dept of State DL Exam Form)', description: 'DS-1972D (Dept of State DL Exam Form)', active: true, sortOrder: 999999 });
        this._dictionary.add('341', { id: 341, value: 'DeptOfStateWaiver', formNumber: '', displayValue: 'Dept of State Waiver', description: 'Dept of State Waiver', active: true, sortOrder: 999999 });
        this._dictionary.add('342', { id: 342, value: 'InvitationalTravelOrders', formNumber: '', displayValue: 'Invitational Travel Orders (ITO)', description: 'Invitational Travel Orders (ITO)', active: true, sortOrder: 999999 });
        this._dictionary.add('343', { id: 343, value: 'I129', formNumber: '', displayValue: 'I-129', description: 'Petition for a Nonimmigrant Worker', active: true, sortOrder: 999999 });
        this._dictionary.add('344', { id: 344, value: 'I829', formNumber: '', displayValue: 'I-829', description: 'Petition by Entrepreneur to Remove Conditions on Permanent Resident Status', active: true, sortOrder: 999999 });
        this._dictionary.add('345', { id: 345, value: 'NATOOrders', formNumber: '', displayValue: 'NATO Orders', description: 'NATO Orders', active: true, sortOrder: 999999 });
        this._dictionary.add('346', { id: 346, value: 'OfficialCertificateLetter', formNumber: '', displayValue: 'Official Certificate/Letter in lieu of Travel Orders', description: 'Official Certificate/Letter in lieu of Travel Orders', active: true, sortOrder: 999999 });
        this._dictionary.add('347', { id: 347, value: 'NonEligibilityLetter', formNumber: '', displayValue: 'Non-Eligibility Letter from Dept of State Office of Foreign Missions', description: 'Non-Eligibility Letter from Dept of State Office of Foreign Missions', active: true, sortOrder: 999999 });
        this._dictionary.add('348', { id: 348, value: 'ImmigrationOrder', formNumber: '', displayValue: 'Immigration Order granting Asylum', description: 'Immigration Order granting Asylum', active: true, sortOrder: 999999 });
        this._dictionary.add('349', { id: 349, value: 'RefundReceipt', formNumber: '', displayValue: 'Refund Receipt', description: 'Refund Receipt', active: true, sortOrder: 999999 });
        this._dictionary.add('350', { id: 350, value: 'PaymentReceipt', formNumber: '', displayValue: 'Payment Receipt', description: 'Payment Receipt', active: true, sortOrder: 999999 });
        this._dictionary.add('351', { id: 351, value: 'APConversionOther', formNumber: '', displayValue: 'AP Conversion - Other', description: 'Other Authorized Presence Conversion Documents', active: true, sortOrder: 999999 });
        this._dictionary.add('352', { id: 352, value: 'ForeignPassport', formNumber: '', displayValue: 'Unexpired Foreign Passport', description: 'Unexpired Foreign Passport', active: true, sortOrder: 999999 });
        this._dictionary.add('353', { id: 353, value: 'IRSForm2290', formNumber: '2290', displayValue: 'IRS Form 2290', description: 'IRS required document when registering a vehicle 55000 pounds or more', active: true, sortOrder: 999999 });
        this._dictionary.add('354', { id: 354, value: 'NoticeProviderForm', formNumber: '', displayValue: 'Notice to Provider Form', description: 'Notice to Provider Form', active: true, sortOrder: 999999 });
        this._dictionary.add('355', { id: 355, value: 'Correspondence', formNumber: '', displayValue: 'Correspondence', description: 'Correspondence', active: true, sortOrder: 999999 });
        this._dictionary.add('356', { id: 356, value: 'TempCredDLPermit21Older', formNumber: '', displayValue: 'Temporary Credential for DL or Permit 21 and Older', description: 'Temporary Credential for DL or Permit 21 and Older', active: false, sortOrder: 999999 });
        this._dictionary.add('357', { id: 357, value: 'TempCredDLPermitUnder21', formNumber: '', displayValue: 'Temporary Credential for DL or Permit Under 21', description: 'Temporary Credential for DL or Permit Under 21', active: false, sortOrder: 999999 });
        this._dictionary.add('358', { id: 358, value: 'TempCredCDL21Older', formNumber: '', displayValue: 'Temporary Credential CDL or CLP 21 and Older', description: 'Temporary Credential CDL or CLP 21 and Older', active: false, sortOrder: 999999 });
        this._dictionary.add('359', { id: 359, value: 'TempCredCDLUnder21', formNumber: '', displayValue: 'Temporary Credential CDL or CLP Under 21', description: 'Temporary Credential CDL or CLP Under 21', active: false, sortOrder: 999999 });
        this._dictionary.add('360', { id: 360, value: 'TempCredID21Older', formNumber: '', displayValue: 'Temporary Credential ID 21 and Older', description: 'Temporary Credential ID 21 and Older', active: false, sortOrder: 999999 });
        this._dictionary.add('361', { id: 361, value: 'TempCredIDUnder21', formNumber: '', displayValue: 'Temporary Credential ID Under 21', description: 'Temporary Credential ID Under 21', active: false, sortOrder: 999999 });
        this._dictionary.add('362', { id: 362, value: 'I797', formNumber: '', displayValue: 'I-797 Notice of Action', description: 'I-797 Notice of Action', active: true, sortOrder: 999999 });
        this._dictionary.add('363', { id: 363, value: 'SSAReferral', formNumber: '', displayValue: 'SSA Referral  Letter', description: 'SSA Referral Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('364', { id: 364, value: 'I688TemporaryResidentCard', formNumber: '', displayValue: 'I 688 Temporary Resident Card', description: 'I 688 Temporary Resident Card', active: true, sortOrder: 999999 });
        this._dictionary.add('365', { id: 365, value: 'VendorRefund', formNumber: '', displayValue: 'Use Fuel Vendor Refund Application', description: 'Use Fuel Vendor Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('366', { id: 366, value: 'InvoicesReceipts', formNumber: '', displayValue: 'Invoices/Receipts', description: 'Invoices or Receipts', active: true, sortOrder: 999999 });
        this._dictionary.add('367', { id: 367, value: 'ForeignIFTARefund', formNumber: '', displayValue: 'Foreign-Based IFTA Tax Credit Refund Application', description: 'Foreign-Based IFTA Tax Credit Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('368', { id: 368, value: 'IFTAQuarterly', formNumber: '', displayValue: 'IFTA Quarterly Tax Report', description: 'IFTA Quarterly Tax Report', active: true, sortOrder: 999999 });
        this._dictionary.add('369', { id: 369, value: 'IFTALicense', formNumber: '', displayValue: 'IFTA License', description: 'IFTA License', active: true, sortOrder: 999999 });
        this._dictionary.add('370', { id: 370, value: 'ArizonaIFTARefund', formNumber: '', displayValue: 'Arizona-Based IFTA Fuel Tax Refund Application', description: 'Arizona-Based IFTA Fuel Tax Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('371', { id: 371, value: 'IFTATaxFiling', formNumber: '', displayValue: 'IFTA Tax Filing', description: 'IFTA Tax Filing', active: true, sortOrder: 999999 });
        this._dictionary.add('372', { id: 372, value: 'TribalRefund', formNumber: '', displayValue: 'Tribal Member Refund Application', description: 'Tribal Member Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('373', { id: 373, value: 'TribalEnrollment', formNumber: '', displayValue: 'Tribal Enrollment Card', description: 'Tribal Enrollment Card', active: true, sortOrder: 999999 });
        this._dictionary.add('374', { id: 374, value: 'TribalGovRefund', formNumber: '', displayValue: 'Tribal Government Refund Application', description: 'Tribal Government Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('375', { id: 375, value: 'ExporterRefund', formNumber: '', displayValue: 'Exporter Refund Application', description: 'Exporter Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('376', { id: 376, value: 'PurchaseInvoices', formNumber: '', displayValue: 'Purchase Invoices', description: 'Purchase Invoices', active: true, sortOrder: 999999 });
        this._dictionary.add('377', { id: 377, value: 'SalesInvoices', formNumber: '', displayValue: 'Sales Invoices', description: 'Sales Invoices', active: true, sortOrder: 999999 });
        this._dictionary.add('378', { id: 378, value: 'BillOfLading', formNumber: '', displayValue: 'Bill of Lading', description: 'Bill of Lading', active: true, sortOrder: 999999 });
        this._dictionary.add('379', { id: 379, value: 'ExportFTReport', formNumber: '', displayValue: 'Export State(s) Fuel Tax Report', description: 'Export State(s) Fuel Tax Report', active: true, sortOrder: 999999 });
        this._dictionary.add('380', { id: 380, value: 'MVFRefund', formNumber: '96-0466', displayValue: 'Motor Vehicle Fuel Refund Application', description: 'Motor Vehicle Fuel Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('381', { id: 381, value: 'EquipmentList', formNumber: '', displayValue: 'Equipment List', description: 'Equipment List', active: true, sortOrder: 999999 });
        this._dictionary.add('382', { id: 382, value: 'FlightLog', formNumber: '', displayValue: 'Flight Log', description: 'Flight Log', active: true, sortOrder: 999999 });
        this._dictionary.add('383', { id: 383, value: 'ForestRefund', formNumber: '', displayValue: 'Forest Products Use Fuel Refund Application', description: 'Forest Products Use Fuel Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('384', { id: 384, value: 'AZCommerce', formNumber: '', displayValue: 'Arizona Commerce Authority Certification Letter', description: 'Arizona Commerce Authority Certification Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('385', { id: 385, value: 'UseFuelRefund', formNumber: '', displayValue: 'Use Fuel Refund Application', description: 'Use Fuel Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('386', { id: 386, value: 'SummarySchedules', formNumber: '', displayValue: 'Summary Schedules', description: 'Summary Schedules', active: true, sortOrder: 999999 });
        this._dictionary.add('387', { id: 387, value: 'BulkFuelRecon', formNumber: '', displayValue: 'Bulk Fuel Inventory Reconciliation', description: 'Bulk Fuel Inventory Reconciliation', active: true, sortOrder: 999999 });
        this._dictionary.add('388', { id: 388, value: 'ContaminatedFuelRefund', formNumber: '', displayValue: 'Contaminated Fuel Refund Application', description: 'Contaminated Fuel Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('389', { id: 389, value: 'ExplanationOfLoss', formNumber: '', displayValue: 'Letters/Documentation of Explanation of Loss', description: 'Letters/Documentation of Explanation of Loss', active: true, sortOrder: 999999 });
        this._dictionary.add('390', { id: 390, value: 'ReportOOSConvictions', formNumber: '', displayValue: 'FP Report Out Of State Convictions', description: 'Report Out Of State Convictions', active: true, sortOrder: 999999 });
        this._dictionary.add('391', { id: 391, value: 'ReportOOSWithdrawals', formNumber: '', displayValue: 'Report Out Of State Withdrawals', description: 'Report Out Of State Withdrawals', active: true, sortOrder: 999999 });
        this._dictionary.add('392', { id: 392, value: 'AviationRefund', formNumber: '', displayValue: 'Aviation Fuel Refund Application', description: 'Aviation Fuel Refund Application', active: true, sortOrder: 999999 });
        this._dictionary.add('393', { id: 393, value: 'TribalRetailerApplication', formNumber: '', displayValue: 'Tribal Retailer Application', description: 'Tribal Retailer Application', active: true, sortOrder: 999999 });
        this._dictionary.add('394', { id: 394, value: 'TransactionalReport', formNumber: '', displayValue: 'Transactional Report', description: 'Transactional Report', active: true, sortOrder: 999999 });
        this._dictionary.add('395', { id: 395, value: 'FormPortMedicalEligibilityExpiration', formNumber: '', displayValue: 'FP Medical Eligibility Expiration', description: 'FormPort Medical Eligibility Expiration', active: true, sortOrder: 999999 });
        this._dictionary.add('396', { id: 396, value: 'MedicalEligibilityExpiration', formNumber: '', displayValue: 'Medical Eligibility Expiration', description: 'Medical Eligibility Expiration', active: true, sortOrder: 999999 });
        this._dictionary.add('397', { id: 397, value: 'RefundRequestApplication', formNumber: '', displayValue: 'Refund Request Application', description: 'Refund Request Application', active: true, sortOrder: 999999 });
        this._dictionary.add('398', { id: 398, value: 'FormPortDriverLicenseMedicalEligibilityNotice', formNumber: '', displayValue: 'FP Driver License Medical Eligibility Notice', description: 'FormPort Driver License Medical Eligibility Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('399', { id: 399, value: 'FormPortVisionReviewReminder', formNumber: '', displayValue: 'FP Vision Review Reminder', description: 'FormPort VisionReviewReminder', active: true, sortOrder: 999999 });
        this._dictionary.add('400', { id: 400, value: 'FormPortAdditionalRequirement', formNumber: '', displayValue: 'FP Additional Requirements', description: 'FormPort Additional Requirements', active: true, sortOrder: 999999 });
        this._dictionary.add('401', { id: 401, value: 'FormPortDLMedReviewNotice', formNumber: '', displayValue: 'FP Driver License Medical Review Notice', description: 'FormPort Driver License Medical Review Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('402', { id: 402, value: 'DLMedReviewNotice', formNumber: '', displayValue: 'Driver License Medical Review Notice', description: 'Driver License Medical Review Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('403', { id: 403, value: 'FormPortPhotoExpireNotice', formNumber: '', displayValue: 'FP Photo Expiration Notice', description: 'FormPort Photo Expiration Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('404', { id: 404, value: 'PhotoExpireNotice', formNumber: '', displayValue: 'Photo Expiration Notice', description: 'Photo Expiration Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('405', { id: 405, value: 'FormPortNonResidentViolatorCompactConvictionNotice', formNumber: '', displayValue: 'FP Non Resident Violator Compact Conviction Notice', description: 'FormPort Non Resident Violator Compact Conviction Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('406', { id: 406, value: 'FormPortCDLWaiverExpirationNotice', formNumber: '', displayValue: 'FP CDL Waiver Expiration Notice', description: 'FormPort CDL Waiver Expiration Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('407', { id: 407, value: 'FormPortHazmatRenewal', formNumber: '', displayValue: 'FP Hazmat Renewal', description: 'FormPort Hazmat Renewal', active: true, sortOrder: 999999 });
        this._dictionary.add('408', { id: 408, value: 'CDLWaiverExpirationNotice', formNumber: '', displayValue: 'CDL Waiver Expiration Notice', description: 'CDL Waiver Expiration Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('409', { id: 409, value: 'HazmatRenewal', formNumber: '', displayValue: 'Hazmat Renewal', description: 'Hazmat Renewal', active: true, sortOrder: 999999 });
        this._dictionary.add('410', { id: 410, value: 'WithdrawalNoticeNoHearing', formNumber: '', displayValue: 'WithdrawalNoticeNoHearing', description: 'Withdrawal notice without hearing information. ', active: true, sortOrder: 999999 });
        this._dictionary.add('411', { id: 411, value: 'WithdrawalNoticeWithHearing', formNumber: '', displayValue: 'WithdrawalNoticeWithHearing', description: 'Withdrawal notice with hearing information.', active: true, sortOrder: 999999 });
        this._dictionary.add('413', { id: 413, value: 'FormPortUhaulVehTitle', formNumber: '', displayValue: 'FP Uhaul Vehicle Title', description: 'FormPort Uhaul Vehicle Title', active: true, sortOrder: 999999 });
        this._dictionary.add('414', { id: 414, value: 'MiscellaneousDoc', formNumber: '', displayValue: 'Miscellaneous Document', description: 'Miscellaneous Document', active: true, sortOrder: 999999 });
        this._dictionary.add('415', { id: 415, value: 'AbandonedVehicleNotice', formNumber: '46-800', displayValue: 'FP Abandoned Vehicle Notice', description: '46-4800 -  Abandoned Vehicle Notice - Used for notifying customers within the United States. ', active: true, sortOrder: 999999 });
        this._dictionary.add('416', { id: 416, value: 'AbandonedVehicleNoticeOutOfState', formNumber: '44-4604', displayValue: 'Abandoned Vehicle Notice Out of State', description: '44-4604 - Abandoned Vehicle Notice Out of State - Used for notifying customer outside of the United States. ', active: true, sortOrder: 999999 });
        this._dictionary.add('417', { id: 417, value: 'AuthorizationForTransferOfOwnership', formNumber: '46-8922', displayValue: 'FP Authorization for Transfer of Ownership', description: '46-8922 -  Authorization for Transfer of Ownership - Used to notify the applicant can take over the ownership of the abandoned vehicle. ', active: true, sortOrder: 999999 });
        this._dictionary.add('418', { id: 418, value: 'CrushCertificate', formNumber: '46-4801', displayValue: 'FP Authorization To Junk Vehicle', description: '46-4801 - Crush Certificate - Used to notice the applicant the vehicle can be crushed. ', active: true, sortOrder: 999999 });
        this._dictionary.add('419', { id: 419, value: 'EmissionsComplianceNotification', formNumber: '', displayValue: 'Emissions Compliance Notification', description: 'Emissions Compliance Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('420', { id: 420, value: 'FormPortEmissionsComplianceNotification', formNumber: '', displayValue: 'FP Emissions Compliance Notification', description: 'FP Emissions Compliance Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('421', { id: 421, value: 'InsuranceSuspensionNotification', formNumber: '', displayValue: 'Insurance Suspension Notification', description: 'Insurance Suspension Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('422', { id: 422, value: 'FormPortInsuranceSuspensionNotification', formNumber: '', displayValue: 'FP Insurance Suspension Notification', description: 'FP Insurance Suspension Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('423', { id: 423, value: 'ElectronicTitleNotification', formNumber: '', displayValue: 'Electronic Title Notification', description: 'Electronic Title Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('424', { id: 424, value: 'FormPortElectronicTitleNotification', formNumber: '', displayValue: 'FP Electronic Title Notification', description: 'FP Electronic Title Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('425', { id: 425, value: 'WithdrawalNoticeAdministrativeAction', formNumber: '', displayValue: 'WithdrawalNoticeWithHearingAdminAction', description: 'Withdrawal notice with hearing information for administrative actions. ', active: true, sortOrder: 999999 });
        this._dictionary.add('426', { id: 426, value: 'NoticeofRestriction', formNumber: '', displayValue: 'Notice of Restriction ', description: 'Notice of Class G Restrictions being extended due to a court conviction.', active: true, sortOrder: 999999 });
        this._dictionary.add('427', { id: 427, value: 'EDUIErrorReport', formNumber: '', displayValue: 'EDUI Error Report', description: 'EDUI Error Report', active: true, sortOrder: 999999 });
        this._dictionary.add('428', { id: 428, value: 'BuyerETitleTransfer', formNumber: '', displayValue: 'Buyer eTitle Transfer', description: 'Buyer eTitle Transfer', active: true, sortOrder: 999999 });
        this._dictionary.add('429', { id: 429, value: 'FormPortWithdrawalNoticeNoHearing', formNumber: '', displayValue: 'FP Withdrawal Notice No Hearing', description: 'FP Withdrawal notice without hearing information', active: true, sortOrder: 999999 });
        this._dictionary.add('430', { id: 430, value: 'FormPortWithdrawalNoticeWithHearing', formNumber: '', displayValue: 'FP Withdrawal Notice With Hearing', description: 'FP Withdrawal notice with hearing information', active: true, sortOrder: 999999 });
        this._dictionary.add('431', { id: 431, value: 'FPDriverNotice', formNumber: '', displayValue: 'FP Driver Notice', description: 'FormPort Notice to notify the customer they need to download an important document from their AZ MVD Now Account.', active: true, sortOrder: 999999 });
        this._dictionary.add('432', { id: 432, value: 'DriverNotice', formNumber: '', displayValue: 'Driver Notice', description: 'Notice to notify the customer they need to download an important document from their AZ MVD Now Account. ', active: true, sortOrder: 999999 });
        this._dictionary.add('433', { id: 433, value: 'FormPortReportOOSWithdrawals', formNumber: '', displayValue: 'FP Report OOS Withdrawals', description: 'FormPort Report OOS Withdrawals', active: true, sortOrder: 999999 });
        this._dictionary.add('434', { id: 434, value: 'FormPortFleetRenewalNotice', formNumber: '', displayValue: 'FP Fleet Renewal Notice', description: 'Fleet Renewal Notice that is sent to FormPort printer', active: true, sortOrder: 999999 });
        this._dictionary.add('435', { id: 435, value: 'TempCredential', formNumber: '', displayValue: 'Temporary Credential', description: 'Temporary Credential', active: true, sortOrder: 999999 });
        this._dictionary.add('436', { id: 436, value: 'VoterRegistrationReceipt', formNumber: '', displayValue: 'Voter Registration Receipt', description: 'Voter Registration Receipt', active: true, sortOrder: 999999 });
        this._dictionary.add('437', { id: 437, value: 'VehicleRegistrationFulfillment', formNumber: '96-0356D', displayValue: 'Vehicle Registration Plate Fulfillment', description: 'Vehicle Registration Fulfillment', active: true, sortOrder: 999999 });
        this._dictionary.add('439', { id: 439, value: 'FormPortTempPlacard', formNumber: '', displayValue: 'FP Temporary Disability Placard', description: 'FP Temporary Disability Placard', active: true, sortOrder: 999999 });
        this._dictionary.add('440', { id: 440, value: 'FormPortPermPlacard', formNumber: '', displayValue: 'FP Permanent Disability Placard', description: 'FP Permanent Disability Placard', active: true, sortOrder: 999999 });
        this._dictionary.add('441', { id: 441, value: 'VehicleTitleShell', formNumber: '', displayValue: 'Vehicle Title Shell', description: 'Vehicle Title Shell', active: true, sortOrder: 999999 });
        this._dictionary.add('442', { id: 442, value: 'SignedAZTitleSummary', formNumber: '', displayValue: 'Signed Arizona Title Summary', description: 'Signed Arizona Title Summary', active: true, sortOrder: 999999 });
        this._dictionary.add('443', { id: 443, value: 'TransferReceipt', formNumber: '', displayValue: 'Transfer Receipt', description: 'Receipt for transferring funds between accounts', active: true, sortOrder: 999999 });
        this._dictionary.add('1290', { id: 1290, value: 'ScanLaterCoverLetter', formNumber: '', displayValue: 'Scan Later Cover Letter', description: 'ScanLaterCoverLetter', active: true, sortOrder: 999999 });
        this._dictionary.add('1291', { id: 1291, value: 'FormPortWithdrawalNoticeAdministrativeAction', formNumber: '', displayValue: 'FP Withdrawal Notice Administrative Action', description: 'FP withdrawal notice administration action. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1292', { id: 1292, value: 'WithdrawalNoticeLawEnforcementAffidavitNoHearing', formNumber: '', displayValue: 'Withdrawal Notice Law Enforcement Affidavit No Hearing', description: 'To be used for withdrawals that do not have a conviction from the courts. No hearing info. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1293', { id: 1293, value: 'FormPortWithdrawalLawEnforcementAffidavitNoHearing', formNumber: '', displayValue: 'FP Withdrawal Notice Law Enforcement Affidavit No Hearing', description: 'FP - To be used for withdrawals that do not have a conviction from the courts. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1294', { id: 1294, value: 'WithdrawalNoticeLawEnforcementAffidavitWithHearing', formNumber: '', displayValue: 'Withdrawal Notice Law Enforcement Affidavit with Hearing', description: 'To be used for withdrawals that do not have a conviction from the courts. With hearing info. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1295', { id: 1295, value: 'FormPortWithdrawalLawEnforcementAffidavitWithHearing', formNumber: '', displayValue: 'FP Withdrawal Law Enforcement Affidavit with Hearing', description: 'FP - To be used for withdrawals that do not have a conviction from the courts. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1296', { id: 1296, value: 'RestrictedLicenseEligibilityNotice', formNumber: '', displayValue: 'Restricted License Eligibility Notice', description: 'Notice used to notify a customer they qualify for a SIIRDL (special ignition interlock drivers license). ', active: true, sortOrder: 999999 });
        this._dictionary.add('1297', { id: 1297, value: 'FormPortRestrictedLicenseEligibilityNotice', formNumber: '', displayValue: 'FP Restricted License Eligibility Notice', description: 'FP - Notice used to notify a customer they qualify for a SIIRDL (special ignition interlock drivers license). ', active: true, sortOrder: 999999 });
        this._dictionary.add('1298', { id: 1298, value: 'IIDExtensionNoticewithWithHearing', formNumber: '', displayValue: 'IID Extension Notice With Hearing', description: 'IID extension notice with hearing.', active: true, sortOrder: 999999 });
        this._dictionary.add('1299', { id: 1299, value: 'FormPortIIDExtensionNoticeWithHearing', formNumber: '', displayValue: 'FP IID Extension Notice With Hearing', description: 'FP IID extension notice with hearing.', active: true, sortOrder: 999999 });
        this._dictionary.add('1300', { id: 1300, value: 'NSFNotice', formNumber: '', displayValue: 'NSF Notice', description: 'NSF Notice. Used for non sufficient funds. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1301', { id: 1301, value: 'FormPortNSFNotice', formNumber: '', displayValue: 'FP NSF Notice', description: 'FP NSF Notice. Used for non sufficient funds. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1302', { id: 1302, value: 'CredentialsCancelledNotice', formNumber: '', displayValue: 'Credentials Cancelled Notice', description: 'Notice used to notify a customers credentials have been cancelled and their privileges to drive are impacted. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1303', { id: 1303, value: 'FormPortCredentialsCancelledNotice', formNumber: '', displayValue: 'FP Credentials Cancelled Notice', description: 'FP Notice used to notify a customers credentials have been cancelled and their privileges to drive are impacted. ', active: true, sortOrder: 999999 });
        this._dictionary.add('1304', { id: 1304, value: 'IIDExtensionNoticeNoHearing', formNumber: '', displayValue: 'IID Extension Notice No Hearing', description: 'IID Extension Notice No Hearing', active: true, sortOrder: 999999 });
        this._dictionary.add('1305', { id: 1305, value: 'FormPortIIDExtensionNoticeNoHearing ', formNumber: '', displayValue: 'FP IID Extension Notice No Hearing', description: 'FP IID Extension Notice No Hearing', active: true, sortOrder: 999999 });
        this._dictionary.add('1306', { id: 1306, value: 'ReturnedMail', formNumber: '', displayValue: 'Returned Mail', description: 'Mail that has been returned as undeliverable', active: true, sortOrder: 999999 });
        this._dictionary.add('1307', { id: 1307, value: 'AZIssuedDL', formNumber: '', displayValue: 'AZ Issued DL', description: 'AZ Issued DL', active: true, sortOrder: 999999 });
        this._dictionary.add('1308', { id: 1308, value: 'NoticeOfAction', formNumber: '', displayValue: 'Notice of Action', description: 'Notice of Action can be used to satisfy INS requirements', active: true, sortOrder: 999999 });
        this._dictionary.add('1309', { id: 1309, value: 'ForeignBirthCertificate', formNumber: '', displayValue: 'Foreign Birth Certificate', description: 'Foreign Birth Certificate', active: true, sortOrder: 999999 });
        this._dictionary.add('1310', { id: 1310, value: 'UnexpiredForeignDriverLicense', formNumber: '', displayValue: 'Unexpired Foreign Driver License', description: 'Unexpired Foreign Driver License', active: true, sortOrder: 999999 });
        this._dictionary.add('1311', { id: 1311, value: 'IRP-IFTA', formNumber: '', displayValue: 'IRP-IFTA', description: 'IRP-IFTA', active: true, sortOrder: 999999 });
        this._dictionary.add('1312', { id: 1312, value: 'CourtPaperAbstracts', formNumber: '', displayValue: 'Court Paper Abstracts', description: 'Court Paper Abstracts', active: true, sortOrder: 999999 });
        this._dictionary.add('1313', { id: 1313, value: 'LawEnforcementAffidavit', formNumber: '', displayValue: 'Law Enforcement Affidavit', description: 'Law Enforcement Affidavit', active: true, sortOrder: 999999 });
        this._dictionary.add('1314', { id: 1314, value: 'HazmatEndorsementCancellationNotice', formNumber: '', displayValue: 'Hazmat Endorsement Cancellation Notice', description: 'Hazmat Endorsement Cancellation Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('1315', { id: 1315, value: 'FormPortHazmatEndorsementCancellationNotice', formNumber: '', displayValue: 'FP Hazmat Endorsement Cancellation Notice', description: 'FP Hazmat Endorsement Cancellation Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('1316', { id: 1316, value: 'FormPortWithdrawalNoticeVehicleRegistrationConditionNotice', formNumber: '', displayValue: 'FP Vehicle Registration Condition Notice', description: 'FP Vehicle Registration Condition Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('1317', { id: 1317, value: 'WithdrawalNoticeVehicleRegistationConditionNotice', formNumber: '', displayValue: 'Vehicle Registration Condition Notice', description: 'Vehicle Registration Condition Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('1318', { id: 1318, value: 'SubstanceAbuseEvaluationOrder', formNumber: '40-0104', displayValue: 'Substance Abuse Evaluation Order', description: 'Substance Abuse Evaluation Order', active: true, sortOrder: 999999 });
        this._dictionary.add('1319', { id: 1319, value: 'IgnitionInterlockDefermentEligibleNotice', formNumber: '15-1044 R12/19', displayValue: 'Ignition Interlock Deferment Eligible Notice', description: 'Ignition Interlock Deferment Eligible Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('1320', { id: 1320, value: 'FormPortIgnitionInterlockDefermentEligibleNotice', formNumber: '15-1044 R12/20', displayValue: 'FP Ignition Interlock Deferment Eligible Notice', description: 'FP Ignition Interlock Deferment Eligible Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('1321', { id: 1321, value: 'IgnitionInterlockDeferment', formNumber: '15-1042 R12/19', displayValue: 'Ignition Interlock Deferment', description: 'Ignition Interlock Deferment', active: true, sortOrder: 999999 });
        this._dictionary.add('1322', { id: 1322, value: 'FormPortIgnitionInterlockDeferment', formNumber: '15-1042 R12/19', displayValue: 'FP Ignition Interlock Deferment', description: 'FP Ignition Interlock Deferment', active: true, sortOrder: 999999 });
        this._dictionary.add('1323', { id: 1323, value: 'StayLetter', formNumber: '', displayValue: 'Stay Letter', description: 'Withdrawal Stay Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('1324', { id: 1324, value: 'StayLetterSummary', formNumber: '', displayValue: 'Stay Letter Summary', description: 'Withdrawal Stay Letter Summary', active: true, sortOrder: 999999 });
        this._dictionary.add('1325', { id: 1325, value: 'FormPortStayLetter', formNumber: '', displayValue: 'FP Stay Letter', description: 'Form Port Withdrawal Stay Letter', active: true, sortOrder: 999999 });
        this._dictionary.add('1326', { id: 1326, value: 'FormPortStayLetterSummary ', formNumber: '', displayValue: 'FP Stay Letter Summary', description: 'Form Port Withdrawal Stay Letter Summary', active: true, sortOrder: 999999 });
        this._dictionary.add('1327', { id: 1327, value: 'WrittenConsentJudgement', formNumber: '', displayValue: 'Written Consent Judgement', description: 'Written Consetn - Foreign Written Consent out of state', active: true, sortOrder: 999999 });
        this._dictionary.add('1328', { id: 1328, value: 'RevokedConsentJudgement', formNumber: '', displayValue: 'Revoked Consent Judgement', description: 'Revoked Consent Judgement', active: true, sortOrder: 999999 });
        this._dictionary.add('1329', { id: 1329, value: 'RenewalOfJudgement', formNumber: '', displayValue: 'Renewal of Judgement', description: 'Renewal of Judgement', active: true, sortOrder: 999999 });
        this._dictionary.add('1330', { id: 1330, value: 'NonRenewalOfJudgement', formNumber: '', displayValue: 'Non Renewal of Judgement', description: 'Non Renewal of Judgement', active: true, sortOrder: 999999 });
        this._dictionary.add('1331', { id: 1331, value: 'SatisfactionForeignSatisfaction', formNumber: '', displayValue: 'Satisfaction - Foreign Satisfaction', description: 'Satisfaction - Foreign Satisfaction', active: true, sortOrder: 999999 });
        this._dictionary.add('1332', { id: 1332, value: 'SetAsideJudgement', formNumber: '', displayValue: 'Set Aside Judgement', description: 'Set Aside Judgement', active: true, sortOrder: 999999 });
        this._dictionary.add('1333', { id: 1333, value: 'VacateVoidDismissalJudgement', formNumber: '', displayValue: 'Vacate Void Dismissal Judgement', description: 'Vacate Void Dismissal Judgement', active: true, sortOrder: 999999 });
        this._dictionary.add('1334', { id: 1334, value: 'PetitionToReinstate', formNumber: '', displayValue: 'Petition To Reinstate', description: 'Petition To Reinstate', active: true, sortOrder: 999999 });
        this._dictionary.add('1335', { id: 1335, value: 'StipulationPetitionApproved', formNumber: '', displayValue: 'Stipulation Petition Approved', description: 'Stipulation Petition Approved', active: true, sortOrder: 999999 });
        this._dictionary.add('1336', { id: 1336, value: 'FinalDischargeBancruptcy', formNumber: '', displayValue: 'Final Discharge Bankruptcy', description: 'Final Discharge Bankruptcy', active: true, sortOrder: 999999 });
        this._dictionary.add('1337', { id: 1337, value: 'ArizonaTravelID', formNumber: '', displayValue: 'Arizona Travel ID', description: 'Arizona Travel ID', active: true, sortOrder: 999999 });
        this._dictionary.add('1338', { id: 1338, value: 'ArizonaTravelCDL', formNumber: '', displayValue: 'Arizona Travel CDL', description: 'Arizona Travel CDL', active: true, sortOrder: 999999 });
        this._dictionary.add('1339', { id: 1339, value: 'ArizonaTravelMotorcycle', formNumber: '', displayValue: 'Arizona Travel Motorcycle', description: 'Arizona Travel Motorcycle', active: true, sortOrder: 999999 });
        this._dictionary.add('1340', { id: 1340, value: 'ArizonaTravelDL', formNumber: '', displayValue: 'Arizona Travel DL', description: 'Arizona Travel DL', active: true, sortOrder: 999999 });
        this._dictionary.add('1341', { id: 1341, value: 'ArizonaID', formNumber: '', displayValue: 'Arizona ID', description: 'Arizona ID', active: true, sortOrder: 999999 });
        this._dictionary.add('1342', { id: 1342, value: 'ArizonaCDL', formNumber: '', displayValue: 'Arizona CDL', description: 'Arizona CDL', active: true, sortOrder: 999999 });
        this._dictionary.add('1343', { id: 1343, value: 'ArizonaMotorcycle', formNumber: '', displayValue: 'Arizona Motorcycle', description: 'Arizona Motorcycle', active: true, sortOrder: 999999 });
        this._dictionary.add('1344', { id: 1344, value: 'ArizonaDL', formNumber: '', displayValue: 'Arizona DL', description: 'Arizona DL', active: true, sortOrder: 999999 });
        this._dictionary.add('2303', { id: 2303, value: 'AllTitleDocuments', formNumber: '', displayValue: 'All Title Documents', description: 'All Title Documents', active: true, sortOrder: 999999 });
        this._dictionary.add('2304', { id: 2304, value: 'Towed Vehicle', formNumber: '96-0115', displayValue: 'FP Towed Vehicle', description: 'FP Towed Vehicle', active: true, sortOrder: 999999 });
        this._dictionary.add('2311', { id: 2311, value: 'EHODecisionAndOrder', formNumber: '', displayValue: 'EHO Decision and Order', description: 'EHO Decision and Order', active: true, sortOrder: 999999 });
        this._dictionary.add('2317', { id: 2317, value: 'FP Order of Suspension/Cancellation Fraud', formNumber: '96-088', displayValue: 'FP Order of Suspension/Cancellation Fraud', description: 'Formport Order of Suspension/Cancellation Fraud', active: true, sortOrder: 999999 });
        this._dictionary.add('2318', { id: 2318, value: 'Order of Suspension/Cancellation Fraud', formNumber: '96-088', displayValue: 'Order of Suspension/Cancellation Fraud', description: 'Order of Suspension/Cancellation Fraud', active: true, sortOrder: 999999 });
        this._dictionary.add('2319', { id: 2319, value: 'OwnerAffidavitSale', formNumber: '', displayValue: 'Owner Affidavit Sale', description: 'Owner Affidavit Sale', active: true, sortOrder: 999999 });
        this._dictionary.add('2322', { id: 2322, value: 'TSSAssignmentsNoHearing', formNumber: '15-1033', displayValue: 'TSS Assignments No Hearing', description: 'TSS Assignments No Hearing', active: true, sortOrder: 999999 });
        this._dictionary.add('2323', { id: 2323, value: 'TSSAssignmentsWithHearing', formNumber: '15-1038', displayValue: 'TSS Assignments With Hearing', description: 'TSS Assignments With Hearing', active: true, sortOrder: 999999 });
        this._dictionary.add('2324', { id: 2324, value: 'FleetRenewalInvite', formNumber: '', displayValue: 'Fleet Renewal Invite', description: 'Fleet Renewal Invitation', active: true, sortOrder: 999999 });
        this._dictionary.add('2326', { id: 2326, value: 'FPNonResidentViolationCompactClearNotice', formNumber: '15-1053', displayValue: 'FP Non Resident Violation Compact Clear Notice', description: 'FormPort Non Resident Violation Compact Clear Notice', active: true, sortOrder: 999999 });
        this._dictionary.add('2331', { id: 2331, value: 'CDL Waiver Documents', formNumber: '', displayValue: 'CDL Waiver Documents For MRP Staff Only', description: 'CDL Waiver Documents', active: true, sortOrder: 999999 });
        this._dictionary.add('2332', { id: 2332, value: 'FMS Billing Notification', formNumber: '15-1058', displayValue: 'FMS Billing Notification', description: 'FMS Billing Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('2333', { id: 2333, value: 'FP FMS Billing Notification', formNumber: '15-1058', displayValue: 'FP FMS Billing Notification', description: 'FP FMS Billing Notification', active: true, sortOrder: 999999 });
        this._dictionary.add('2334', { id: 2334, value: 'MVDComplianceRequired', formNumber: '', displayValue: 'MVD Compliance Required', description: 'MVD Compliance Required', active: true, sortOrder: 999999 });
        this._dictionary.add('2335', { id: 2335, value: 'WindowTintApplication', formNumber: '', displayValue: 'Window Tint Medical Exemption Application', description: 'Window Tint Medical Exemption Application', active: true, sortOrder: 999999 });
        this._dictionary.add('2352', { id: 2352, value: 'OtherDocumentWithI94', formNumber: '', displayValue: 'Other Document With an I-94 number', description: 'Other Document With an I-94 number', active: true, sortOrder: 999999 });
        this._dictionary.add('2353', { id: 2353, value: 'OtherDocumentWithANumber', formNumber: '', displayValue: 'Other Document With an A number', description: 'Other Document With an A number', active: true, sortOrder: 999999 });
        this._dictionary.add('2378', { id: 2378, value: 'MCProofNameAddressChange', formNumber: '', displayValue: 'Motor Carrier Proof of Name or Address Change', description: 'Motor Carrier Proof of Name or Address Change', active: true, sortOrder: 999999 });
        this._dictionary.add('2435', { id: 2435, value: 'FleetVehicleCredit', formNumber: '', displayValue: 'Fleet Vehicle Credit', description: 'Fleet Vehicle Credit', active: true, sortOrder: 999999 });
        this._dictionary.add('2439', { id: 2439, value: 'AgreementExhibits', formNumber: '', displayValue: 'Agreement and Exhibits', description: 'Agreement and Exhibits', active: true, sortOrder: 999999 });
        this._dictionary.add('2440', { id: 2440, value: 'LetterofRenewal', formNumber: '', displayValue: 'Joint Letter of Renewal', description: 'Joint Letter of Renewal', active: true, sortOrder: 999999 });
        this._dictionary.add('2506', { id: 2506, value: 'ExhibitATitleAndRegistrationAuthorizedActivities', formNumber: '', displayValue: 'Exhibit A Title and Registration Authorized Activities', description: 'Exhibit A Title and Registration Authorized Activities', active: true, sortOrder: 999999 });
        this._dictionary.add('2507', { id: 2507, value: 'ExhibitBOnlyForCompaniesWithBranchLocations', formNumber: '', displayValue: 'Exhibit B Only for Companies with Branch Locations', description: 'Exhibit B Only for Companies with Branch Locations', active: true, sortOrder: 999999 });
        this._dictionary.add('2508', { id: 2508, value: 'ExhibitCInsuranceAndBondingRequirements', formNumber: '', displayValue: 'Exhibit C Insurance and Bonding Requirements', description: 'Exhibit C Insurance and Bonding Requirements', active: true, sortOrder: 999999 });
        this._dictionary.add('2509', { id: 2509, value: 'ExhibitDPerformanceMeasurements', formNumber: '', displayValue: 'Exhibit D Performance Measurements', description: 'Exhibit D Performance Measurements', active: true, sortOrder: 999999 });
        this._dictionary.add('2510', { id: 2510, value: 'ExhibitENonDiscrimination', formNumber: '', displayValue: 'Exhibit E Non-Discrimination', description: 'Exhibit E Non-Discrimination', active: true, sortOrder: 999999 });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDocumentType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IDocumentType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDocumentType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDocumentType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDocumentType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
